import $ from 'jquery';
import DatePicker from 'material-ui/DatePicker';
import MenuItem from 'material-ui/MenuItem';
// import TextField from '@material-ui/core/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import SelectField from 'material-ui/SelectField';
import TextField from 'material-ui/TextField';
import PropTypes from 'prop-types';
import React from 'react';
import InputMask from 'react-input-mask';
import moment from 'moment';
import Recaptcha from 'react-recaptcha';
import { connect } from 'react-redux';
import Loader from '../loader/loader.jsx';
import {
    Link, withRouter
} from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import KeyboardedInput from 'react-touch-screen-keyboard';
import 'react-touch-screen-keyboard/lib/Keyboard.css';
import * as actions from '../../actions/actions.jsx';
import services from '../../services/allservices.jsx';
import '../../stylesheet/activate.css';
import '../../stylesheet/signin.css';
import '../../stylesheet/virtualkeyboard.css';
import CardDesign from '../carddesign/carddesign.jsx';
import ConsumerPdfViewer from './kycdocumentviewer'
import LoaderSmall from "../loader/loadersmall.jsx";
import { Document, Page } from 'react-pdf'
import MultipleSelect from '../common/multiselect.jsx';
import FormHelperText from '@material-ui/core/FormHelperText';
// import Autosuggest from 'react-autosuggest';
import { Error, errorParser } from '../../components/common/validations'
import UserModal from './regmodal.jsx';
import ActivationSuccess from './activationsuccess.jsx';
import ActivationFailed from './activationfailed.jsx';
import Checkbox from '@material-ui/core/Checkbox'
import { TramRounded } from '@material-ui/icons';
import { getClientId, getClientSecret, buildClientHeader } from '../../utils/clientAuth';
import uuidv4 from 'uuid/v4';

// import StepComp from './stepcomp.jsx'
/**
 * Vertical steppers are designed for narrow screen sizes. They are ideal for mobile.
 *
 * To use the vertical stepper with the contained content as seen in spec examples,
 * you must use the `<StepContent>` component inside the `<Step>`.
 *
 * <small>(The vertical stepper can also be used without `<StepContent>` to display a basic stepper.)</small>
 */


const styles = {
    stepbutton: {
        fill: "rgb(48, 86, 151)"
    },
    focusStyle: {
        borderTop: "none #333",
        borderLeft: "none #333",
        borderRight: "none #333",
        borderBottom: "2px solid #333"
    },
    focusTextStyle: {
        color: "#333"
    }
}

// const escapeRegexCharacters = str => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');


// const getSuggestions = (value, countryState) => {
//     const escapedValue = escapeRegexCharacters(value.trim());

//     if (escapedValue === '') {
//         return [];
//     }

//     const regex = new RegExp('^' + escapedValue, 'i');

//     const suggestions = countryState.filter(country => regex.test(country.name));

//     if (suggestions.length === 0) {
//         return [
//             { name: "No Country Found" }
//         ];
//     }

//     return suggestions;
// }


const mapStateToProps = state =>
({
    publicKey: state.publicKey.publicKey,
    keyRecieved: state.publicKey.keyRecieved,
    cardNumber: state.stoteCardDetail.cardNumber,
    secretQues: state.secretQuesReducer.secretQues,
    quesReceived: state.secretQuesReducer.quesReceived,
    validUserIdState: state.getValidIdReducer.validUserIdState,
    activationcardState: state.getactivationcardReducer.activationcardState,
    countryState: state.countryReducer.countryState,
    cardImageState: state.getCardImageReducer.cardImageState,
})
const mapDispatchToProps = dispatch =>
({
    fetchPublicKey(keyRecieved) {
        dispatch(
            actions.publicKeyAction(keyRecieved)
        )
    },
    fetchCardImage(programId) {
        dispatch(
            actions.getCardImageAction(programId)
        )
    },
    fetchSecretQues(quesReceived) {
        dispatch(
            actions.secretQuesAction(quesReceived)
        )
    },
    validateUserId(username) {

        dispatch(
            actions.validateUserIdAction(username)
        )
    },
    getactivation(state) {

        dispatch(
            actions.getactivationcardAction(state)

        )
    },
    fetchCountryState() {
        dispatch(
            actions.countryAction()
        )
    },
    // storeCardNumber(cardNumber) {
    //     dispatch(
    //         actions.storeCardDetail(cardNumber)
    //     )
    // },
})

var callback = function () {

};

// specifying verify callback function

const JSEncrypt = window.JSEncrypt;

class Activate extends React.Component {

    constructor(props) {
        super(props);
        this.handleActivate = this.handleActivate.bind(this)
        this.onChange = this.onChange.bind(this)
        this.handleUserInfo = this.handleUserInfo.bind(this)
        this.handleVerify = this.handleVerify.bind(this)
        this.findDescription = this.findDescription.bind(this)
        this.handleActiveUser = this.handleActiveUser.bind(this)
        this.validusernameresp = this.validusernameresp.bind(this)
        this.handelvalidateexistingusername = this.handelvalidateexistingusername.bind(this)
        this.handelvalidatepassword = this.handelvalidatepassword.bind(this)
        this.multipleSelect = this.multipleSelect.bind(this)
        this.handleMobile = this.handleMobile.bind(this)
        this.handleKeyPress = this.handleKeyPress.bind(this)
        this.fileRef = React.createRef()
        this.errors = new Error()
        this.handleDateOfBirth = this.handleDateOfBirth.bind(this)
        this.handleExpiry = this.handleExpiry.bind(this)
        this.handleSecretDate = this.handleSecretDate.bind(this)

    }

    state = {
        response: "",
        activatedCardNumber: "",
        activatedFirstName: "",
        activatedLastName: "",
        activatedExpDate: "",
        stepIndex: JSON.parse(localStorage.getItem('step')),
        balance: "",
        pin: "",
        confirmPin: "",
        correctUsername: true,
        correctFirstname: true,
        correctLastname: true,
        correctGender: true,
        correctDateofbirth: true,
        correctMobileNumber: true,
        correctEmail: true,
        correctAddress: true,
        // correctAddress1: true,
        correctState: true,
        correctCountry: true,
        correctPincode: true,
        correctPassword: true,
        correctConfirmPassword: true,
        validUserName: true,
        correctAnswer: true,
        correctCity: true,
        correctAnswerDate: true,
        cardType: localStorage.getItem('cardTypes'),
        customMapping: [],
        expiryMonth: localStorage.getItem('expiry'),
        cardNumber: '',
        idNumber: "",
        // extraData: "",
        confirmPinError: false,
        validUserId: true,
        PinMatchecdError: false,
        pinError: false,
        expiryError: false,
        expiryDate: "",
        expiry: "",
        openWrongPinSnac: false,
        value: "", secretPassword: "", userName: "", password: "", emailId: "", confirmPassword: "",
        secretPasswordDate: "",
        usernameVerified: false,
        suggestions: [],
        countryState: [],
        activationcardState: [],
        value3: '',
        // disabled: true,
        submitBtndisabled: true,
        verifyBtndisabled: true,
        validUserBtndisabled: true,
        validUser: true,
        NextBtndisabled: true,
        abcdisabled: true,
        correctpin: true,
        openModal: false,
        showThirdStep: false,
        existingUser: localStorage.getItem('existingUser'),
        streetNumber: "",
        countryName: "",
        countryName1: localStorage.getItem('pform') === 'AU' ? 'AUS' : 'NZL',
        countryCode1: localStorage.getItem('pform') === 'AU' ? "Australia" : "New Zealand",
        countryCode: localStorage.getItem('pform') === 'AU' ? 'AUS' : 'NZL',
        isenabled: true,
        firstName: '',
        lastName: '',
        gender: '',
        emailId: localStorage.getItem('emailId'),
        mobileNumber: localStorage.getItem('mobileNumber'),
        address: '',
        address2: '',
        city: '',
        pincode: '',
        state: '',
        secretAnswer: '',
        isvalidSecretAnswer: true,
        loader5: false,
        // secretAnswerDate: '',

        dateSelected: false,
        dateSelect: false,
        genderSelected: false,
        toggleType: "password",
        toggleType1: "text",
        toggleText: "text",
        togglePINIcon: "fa fa-eye-slash",
        toggleConfirmPINIcon: "fa fa-eye-slash",
        togglePass: "password",
        toggleConfirmPass: "password",
        togglePassIcon: "fa fa-eye-slash",
        toggleConfirmPassIcon: "fa fa-eye-slash",
        toggleLoginType: "password",
        toggleLoginIcon: "fa fa-eye-slash",
        val: "",
        state1: "",
        errorText: '',
        firstNameError: '',
        description: "Date of Birth",
        secretQuestionCode: "DOB",
        parsedErrors: {},
        idType: "DRIVERS_LICENCE",
        idExpiry: "",
        idExpiry1: "",
        documentFront: "",
        activationsuccess: false,
        activationfailed: false,
        EnableCheckbox: false,
        KycConsent: false,
        isvalidDOB: true,
        isvalidExpiry: true,
        disabledBtn: true,
        // dateofbirth: '',
        // secretAnswerDate:'',
        // dateofbirth: new Date (),
        // secretAnswerDate:new Date (),


    };


    componentDidUpdate() {
        if (this.props.countryState !== this.state.countryState) {
            this.setState({ countryState: this.props.countryState })
        }
        const isDigitalCard = localStorage.getItem('isDigitalCard')
        if (this.props.activationcardState !== this.state.activationcardState) {
            this.setState({
                activationcardState: this.props.activationcardState,
                firstName: isDigitalCard === 'true' ? localStorage.getItem('firstName') : this.props.activationcardState && this.props.activationcardState.body && this.props.activationcardState.body.firstName,
                lastName: isDigitalCard === 'true' ? localStorage.getItem('lastName') : this.props.activationcardState && this.props.activationcardState.body && this.props.activationcardState.body.lastName,
                middleName: isDigitalCard === 'true' ? localStorage.getItem('middleName') : this.props.activationcardState && this.props.activationcardState.body && this.props.activationcardState.body.middleName,
                dateofbirth: isDigitalCard === 'true' ? localStorage.getItem('dateofbirth') : this.converSelectedDate(new Date(this.props.activationcardState && this.props.activationcardState.body && this.props.activationcardState.body.specialDate)),
                //dateofbirth: this.props.activationcardState && this.props.activationcardState.body && this.props.activationcardState.body.specialDate,
                address: isDigitalCard === 'true' ? localStorage.getItem('address') : this.props.activationcardState && this.props.activationcardState.body && this.props.activationcardState.body.address,
                address2: isDigitalCard === 'true' ? localStorage.getItem('address2') : this.props.activationcardState && this.props.activationcardState.body && this.props.activationcardState.body.address2,
                emailId: isDigitalCard === 'true' ? localStorage.getItem('emailId') : this.props.activationcardState && this.props.activationcardState.body && this.props.activationcardState.body.emailId,
                mobileNumber: isDigitalCard === 'true' ? localStorage.getItem('mobileNumber') : this.props.activationcardState && this.props.activationcardState.body && this.props.activationcardState.body.mobileNumber,
                city: isDigitalCard === 'true' ? localStorage.getItem('city') : this.props.activationcardState && this.props.activationcardState.body && this.props.activationcardState.body.city,
                state: isDigitalCard === 'true' ? localStorage.getItem('state') : this.props.activationcardState && this.props.activationcardState.body && this.props.activationcardState.body.state,
                countryName: isDigitalCard === 'true' ? localStorage.getItem('countryName') : this.props.activationcardState && this.props.activationcardState.body && this.props.activationcardState.body.country,
                pincode: isDigitalCard === 'true' ? localStorage.getItem('pincode') : this.props.activationcardState && this.props.activationcardState.body && this.props.activationcardState.body.pincode,
                countryCode: isDigitalCard === 'true' ? localStorage.getItem('countryCode') : this.props.activationcardState && this.props.activationcardState.body && this.props.activationcardState.body.countryCode,
                dob: isDigitalCard === 'true' ? localStorage.getItem('dob') : this.converSelectedDate(new Date(this.props.activationcardState && this.props.activationcardState.body && this.props.activationcardState.body.specialDate)),
                knectCustomerId: isDigitalCard === 'true' ? localStorage.getItem('knectCustomerId') : this.props.activationcardState && this.props.activationcardState.body && this.props.activationcardState.body.knectCustomerId,
                streetNumber: isDigitalCard === 'true' ? localStorage.getItem('streetNumber') : this.props.activationcardState && this.props.activationcardState.body && this.props.activationcardState.body.streetNumber,
            })
            // 
        }



    }
    handleClick = event => {
        const { target = {} } = event || {};
        target.value = "";
    };




    onFileChange = async (e) => {


        let _this = this
        const file1 = e.target.files[0]



        let filetype = file1.type

        // let extensionType = filetype.slice(6)

        // let _this = this

        var reader = new FileReader();
        reader.onloadend = function () {
            let result1 = reader.result

            let res = result1.slice(result1.indexOf(",") + 1)


            if (file1.size > 1000000) {

                _this.setState({
                    documentFront: "",
                    fileType: "",
                    fileName: "",
                    fileSize: "",
                })
                toast.error('Uploaded File Size Should be Less Than 1 MB', {
                    position: "top-right",
                    draggablePercent: 60,
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false
                });
                // _this.handleClick(e)
            }
            else {
                _this.setState({
                    documentFront: res,
                    fileType: filetype,
                    fileName: file1.name,
                    fileSize: file1.size,
                })
            }
        }
        reader.readAsDataURL(file1);


    }





    handleCapcha(value) {
        this.setState({
            capcha: value
        })
    }
    handleSelect = (event, index, value) => {

        this.findDescription(value)
        this.setState({
            secretQuestionCode: value
        }, () => {

            if (this.state.secretQuestionCode === "DOB") {
                this.setState({
                    secretPassword: this.state.secretPasswordDate
                })

            } else {
                this.setState({
                    secretPassword: this.state.secretAnswer
                })

            }

        });
    }

    findDescription(value) {
        const { secretQues } = this.props
        for (let i = 0; i < secretQues.body.length; i++) {
            if (secretQues.body[i].secretQuestionCode === value) {
                this.setState({ description: secretQues.body[i].description })
            }
        }

    }
    componentDidMount() {
        const { stepIndex } = this.state
        $(".toggle-password").click(function () {

            $(this).toggleClass("fa-eye fa-eye-slash");
            var input = $($(this).attr("toggle"));
            if (input.attr("type") === "password") {
                input.attr("type", "text");
            } else {
                input.attr("type", "password");
            }
        });


        if (stepIndex === 0) {
            // document.getElementById('cofirmpin').addEventListener("keypress", this.handleKeyPress)
            // document.getElementById('pin').addEventListener("keypress", this.handleKeyPress)
        }



        const state = {
            cardNumber: localStorage.getItem('cardNumber'),
            applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex'
        }



        this.props.fetchCountryState()
        // this.props.getactivation(state)
        this.props.fetchPublicKey(false)
        this.props.fetchSecretQues(false)
        // this.props.storeCardNumber(cardNumber)
        this.props.getactivation(state)
        // 

    }

    handleKeyPress(e) {
        e.preventDefault()
        return false;
    }
    handleMobile() {
        const { mobileNumber } = this.state
        // let arr = []
        let no = mobileNumber.split('')
        no.unshift('0')

        let num = no.join('')

        this.setState({
            mobileNumber: num
        })

    }

    handleLogin = () => {
        const { publicKey } = this.props
        this.setState({
            loader5: true
        })

        let _this = this
        const public_Key = publicKey.body.publickey;
        let encrypt = new JSEncrypt();
        encrypt.setPublicKey(public_Key);
        // let expiryDate = _this.state.expiryDate;



        let state = {
            userName: this.state.userName,
            password: this.state.password,
            applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',
            cardNumber: encrypt.encrypt(localStorage.getItem('cdNo')),
            cardType: localStorage.getItem('cardTypes'),
            expiryDate: encrypt.encrypt(this.state.expiryDate),
            cardPin: encrypt.encrypt(_this.state.pin),
        }
        console.log("Sending data handleLogin", state)
        let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ
        let gid = getClientId();
        let traceId = getClientId();


        fetch(plink + services.login, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'clientId': gid,
                'clientSecret': getClientSecret(gid, this.state.userName),
                'X-Trace-Id': traceId,
                'X-Client-APP': buildClientHeader(),
            }),
            body: JSON.stringify(state)
        })
            .then(
                function (response) {
                    if (response.status === 200 || response.status === 201) {

                        if (_this.state.userName === 'admin' && _this.state.password === 'Qwerty@1') {
                            response.json().then(function (json) {
                                let exp = json.expiryInMinutes

                                let expiry = (exp * 60000 + new Date().getTime())

                                localStorage.setItem('expiryTime', JSON.stringify(expiry))
                                localStorage.setItem("loginState", true)
                                localStorage.setItem('memberId', json.memberId);
                                localStorage.setItem('token', json.token)
                                localStorage.setItem('accountId', json.accountId);
                                localStorage.setItem('timeoutvalue', 'first')

                                localStorage.setItem('lastSuccessfulLogin', json.lastSuccessfulLogin);
                                localStorage.setItem('lastUnsuccessfulLogin', json.lastUnsuccessfulLogin);
                                localStorage.setItem('cardTypes', json.cardTypes)
                                localStorage.setItem('newPhysicalCardRequested', json.newPhysicalCardRequested)
                                _this.setState({
                                    loader: false
                                })
                                toast.success(response.headers.get('message'), {
                                    position: "top-right",
                                    draggablePercent: 60,
                                    autoClose: 3000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: false
                                });

                                setTimeout(function () {
                                    _this.props.history.push('/cardsearch');
                                }, 3000);
                            })

                        }
                        else {
                            response.json().then(function (json) {
                                let exp = json.expiryInMinutes

                                let expiry = (exp * 60000 + new Date().getTime())

                                localStorage.setItem('expiryTime', JSON.stringify(expiry))
                                localStorage.setItem("loginState", true)
                                localStorage.setItem('memberId', json.memberId);
                                localStorage.setItem('token', json.token)
                                localStorage.setItem('accountId', json.accountId);

                                localStorage.setItem('lastSuccessfulLogin', json.lastSuccessfulLogin);
                                localStorage.setItem('lastUnsuccessfulLogin', json.lastUnsuccessfulLogin);
                                localStorage.setItem('cardTypes', json.cardTypes)
                                localStorage.setItem('newPhysicalCardRequested', json.newPhysicalCardRequested)
                                if (json.performChangePassword === true) {
                                    setTimeout(function () {
                                        _this.props.history.push('/fchangepassword');
                                    }, 3000);
                                }
                                else if (json.performForceSecretQuestion === true) {
                                    setTimeout(function () {
                                        _this.props.history.push('/ForceChangesecretque');
                                    }, 3000);
                                }
                                else {
                                    _this.setState({
                                        loader5: false
                                    })
                                    toast.success(response.headers.get('message'), {
                                        position: "top-right",
                                        draggablePercent: 60,
                                        autoClose: 3000,
                                        hideProgressBar: false,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: false
                                    });

                                    setTimeout(function () {
                                        _this.props.history.push('/home');
                                    }, 3000);

                                }



                                // _this.props.history.push('/home');
                            })

                        }

                    }
                    else if (response.status === 422) {
                        response.json()
                            .then(json => {
                                let message = json.message ? json.message : response.headers.get('message')
                                //document.getElementById('setpassword').style.display = "block"
                                toast.error(message, {
                                    position: "top-right",
                                    autoClose: 3000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    draggablePercent: 60
                                })
                                _this.setState({
                                    loader5: false
                                })
                                // setTimeout(function () { window.location.reload(true) }, 100) 
                            })
                    }
                    // else if (response.status === 417) {
                    //     _this.setState({
                    //         loader: false
                    //     })
                    //     document.getElementById("myModal").style.display = "block"

                    // }
                    else {
                        _this.setState({
                            loader5: false
                        })

                        toast.error(response.headers.get('message'), {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false
                        });
                    }
                }
            )

    }

    multipleSelect(e) {

        e.preventDefault()
        let body = this.props.countryState

        let item = body.find(item => item.name === e.target.value)
        this.props.multiSelect({ name: [e.target.name], value: item })

    }

    removepwd = () => {
        this.setState({
            correctpawd: true
        })
    }
    removeemail = () => {
        this.setState({
            correctEmail: true
        })
    }



    onChange = (e, value) => {
        const rawExpiry = e.target.value;
        const digitsOnly = rawExpiry.replace('/', '');

        this.setState({ expiry: rawExpiry });

        const isComplete = digitsOnly.length === 4 && !digitsOnly.includes('_') && /^\d{4}$/.test(digitsOnly);
        if (!isComplete) {
            this.setState({ expiryError: false, expiryDate: digitsOnly, expiryVerified: false });
            return;
        }

        this.setState({ expiryDate: digitsOnly, expiryError: false });

        if (this.state.pin === this.state.confirmPin) {
            this.setState({ PinMatchecdError: false });
        } else {
            this.setState({ PinMatchecdError: true });
        }

        const isDigitalCard = localStorage.getItem('isDigitalCard') === 'true';

        let state;

        if (isDigitalCard) {
            state = {

                applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',
                cardExpiry: digitsOnly,

                cardProxyNo: localStorage.getItem('kitNumber')
            };

        }
        else {

            const encryptedCardNumber = localStorage.getItem('eCard') || localStorage.getItem('cardNumber');
            if (!encryptedCardNumber) return;
            state = {

                cardNumber: encryptedCardNumber,
                applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',
                cardExpiry: digitsOnly,


            };
        }

        const plink = localStorage.getItem('pform') === 'AU'
            ? process.env.REACT_APP_SERVICEURL_AU
            : process.env.REACT_APP_SERVICEURL_NZ;
        const gid = getClientId();
        const traceId = getClientId();
        const _this = this;

        // fetch(plink + services.verify_cardExpiry_reg, {
        fetch(plink + (isDigitalCard ? services.verify_cardExpiry_Digital : services.verify_cardExpiry_reg), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'clientId': gid,
                'clientSecret': getClientSecret(gid, digitsOnly),
                'X-Trace-Id': traceId,
                'X-Client-APP': buildClientHeader(),
            },
            body: JSON.stringify(state),
        })
            .then(response => {
                if (response.status === 200 || response.status === 204) {

                    _this.setState({ expiryVerified: true });
                    localStorage.setItem('expiryVerified', true);
                    localStorage.setItem('expiry', digitsOnly);


                    return response.json().then(data => {
                        const stateUpdate = {};

                        // if (isDigitalCard && data.cardNumber) {
                        //     localStorage.setItem('eCard', data.cardNumber); // digital only - physical eCard is untouched here
                        // }
                        if (data.cardNumber) {
                            if (isDigitalCard) {
                                localStorage.setItem('eCard', data.encryptedCardNumber);

                                localStorage.setItem('cardNumber', data.cardNumber); // digital only - physical eCard is untouched here
                            }
                            localStorage.setItem('cardNumber', data.cardNumber); // masked card number from backend, used for display (both digital and physical)
                        }
                        if (data.programId) {
                            localStorage.setItem('programId', data.programId);
                        }
                        //  localStorage.setItem("programId", object.programId)
                        if (data.emailId) {
                            localStorage.setItem('emailId', data.emailId);
                            stateUpdate.emailId = data.emailId;
                        }
                        if (data.accountId) {
                            localStorage.setItem('accountId', data.accountId);
                        }
                        if (data.cardholderId) {
                            localStorage.setItem('cardholderId', data.cardholderId);
                        }
                        if (data.mobileNumber) {
                            localStorage.setItem('mobileNumber', data.mobileNumber);
                            stateUpdate.mobileNumber = data.mobileNumber;
                        }
                        if (data.firstName) {
                            localStorage.setItem('firstName', data.firstName);
                            stateUpdate.firstName = data.firstName;
                        }
                        if (data.lastName) {
                            localStorage.setItem('lastName', data.lastName);
                            stateUpdate.lastName = data.lastName;
                        }
                        if (data.programName) {
                            localStorage.setItem('cardProgram', data.programName);
                        }
                        if (data.knectCustomerId) {
                            localStorage.setItem('knectCustomerId', data.knectCustomerId);
                        }
                        if (data.customerId) {
                            localStorage.setItem('customerId', data.customerId);
                        }

                        if (Object.keys(stateUpdate).length > 0) {
                            _this.setState(stateUpdate);
                        }
                    })
                        .catch(() => {
                            // 200 response with no/invalid JSON body — don't let this
                            // fall through to the outer .catch() and show an error toast
                            // when verification itself actually succeeded.
                        });

                }
                else if (response.status === 422 || response.status === 400) {
                    response.json().then(json => {
                        const message = (json && json.message) || response.headers.get('message');
                        toast.error(message, {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                        });
                    }).catch(() => {
                        const message = response.headers.get('message') || 'Invalid Card Expiry';
                        toast.error(message, {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                        });
                    });
                    _this.setState({ expiryVerified: false });
                    localStorage.setItem('expiryVerified', false);
                }
                else if (response.status === 500) {
                    toast.error('Something went wrong. Please try again.', {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                    });
                    _this.setState({ expiryVerified: false });
                    localStorage.setItem('expiryVerified', false);
                }
                else {
                    toast.error(response.headers.get('message') || 'Unable to verify Card Expiry', {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                    });
                    _this.setState({ expiryVerified: false });
                    localStorage.setItem('expiryVerified', false);
                }
            })
            .catch(() => {
                toast.error('Unable to verify Card Expiry. Please try again.', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
                _this.setState({ expiryVerified: false });
                localStorage.setItem('expiryVerified', false);
            });
    }
    togglePIN = () => {

        if (this.state.toggleType1 === "password") {
            this.setState({
                toggleType1: "text",
                togglePINIcon: "fa fa-fw fa-eye"
            })
        } else {
            this.setState({
                toggleType1: "password",
                togglePINIcon: "fa fa-eye-slash"
            })
        }
    }
    toggleConfirmPIN = () => {
        if (this.state.toggleText === "password") {
            this.setState({
                toggleText: "text",
                toggleConfirmPINIcon: "fa fa-fw fa-eye"
            })
        } else {
            this.setState({
                toggleText: "password",
                toggleConfirmPINIcon: "fa fa-eye-slash"
            })
        }
    }
    togglePassword = () => {

        if (this.state.togglePass === "password") {
            this.setState({
                togglePass: "text",
                togglePassIcon: "fa fa-fw fa-eye"
            })
        } else {
            this.setState({
                togglePass: "password",
                togglePassIcon: "fa fa-eye-slash"
            })
        }
    }
    toggleConfirmPassword = () => {
        if (this.state.toggleConfirmPass === "password") {
            this.setState({
                toggleConfirmPass: "text",
                toggleConfirmPassIcon: "fa fa-fw fa-eye"
            })
        } else {
            this.setState({
                toggleConfirmPass: "password",
                toggleConfirmPassIcon: "fa fa-eye-slash"
            })
        }
    }
    toggleLoginPassword = () => {

        if (this.state.toggleLoginType === "password") {
            this.setState({
                toggleLoginType: "text",
                toggleLoginIcon: "fa fa-fw fa-eye"
            })
        } else {
            this.setState({
                toggleLoginType: "password",
                toggleLoginIcon: "fa fa-eye-slash"
            })
        }
    }

    closeUserModal = () => {
        this.setState({
            activationfailed: false,
            stepIndex: 1
        })
    }
    closeSuccessModal = () => {
        this.setState({
            stepIndex: 2,
            activationsuccess: false
        })
    }
    closefailedModal = () => {
        this.setState({
            activationfailed: false,
            stepIndex: 1
        })
    }

    // handleOldUser = () => {
    //     this.setState({
    //         existingUser: "yes",
    //         stepIndex: 1,
    //         openModal: false,

    //     })
    //     localStorage.setItem('step', this.state.stepIndex)

    // }
    handleOldUser = () => {



        const { publicKey, activationcardState } = this.props

        if (localStorage.getItem("existingUser") === "true" || localStorage.getItem("existingUser") === "yes") {


            let _this = this
            const public_Key = publicKey.body.publickey;
            let encrypt = new JSEncrypt();
            encrypt.setPublicKey(public_Key);

            const state = {
                applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',
                cardNumber: encrypt.encrypt(localStorage.getItem('cdNo')),
                cardType: localStorage.getItem('cardTypes'),
                expiryDate: encrypt.encrypt(this.state.expiryDate),
                cardPin: encrypt.encrypt(_this.state.pin),
                accountId: localStorage.getItem('accountId'),
                // kitNo: this.props.activationcardState.body.kitNo,
                kitNo: localStorage.getItem('kitNumber'),
                // cardholderId: this.props.activationcardState.body.cardholderId,
                cardholderId: localStorage.getItem('cardholderId')
            }
            console.log("Sending data handleolduser", state)
            this.setState({
                loader: true
            })
            let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ
            let greissueid = getClientId()
            let traceId = getClientId();
            fetch(plink + services.Reissue_activate_card, {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'clientId': greissueid,
                    'clientSecret': getClientSecret(greissueid, localStorage.getItem('accountId')),
                    'X-Trace-Id': traceId,
                    'X-Client-APP': buildClientHeader(),

                }),
                body: JSON.stringify(state)
            })
                .then(response => {
                    if (response.status === 200 || response.status === 201) {
                        toast.success(response.headers.get('message'), {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false
                        });
                        setTimeout(function () {
                            _this.props.history.push('/login');
                            localStorage.clear();
                        }, 3000);

                        // redirect to login screen - created internally
                        // this.setState({
                        //     existingUser: "yes",
                        //     stepIndex: 1,
                        //     openModal: false,
                        //     loader: false
                        // })

                        // 
                    } else {
                        this.setState({
                            loader: false
                        })
                        toast.error(response.headers.get('message'), {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true
                        });
                    }
                })
        }
        else {
            this.setState({
                existingUser: "yes",
                stepIndex: 1,
                openModal: false,
                loader: false
            }, () => {
                localStorage.setItem('step', this.state.stepIndex)
                localStorage.setItem('existingUser', 'yes')
            })
        }



    }

    handleNewUser = () => {
        this.setState({
            existingUser: "no",
            stepIndex: 1,
            openModal: false,
            isenabled: true
        }, () => {
            localStorage.setItem('step', this.state.stepIndex)
            localStorage.setItem('existingUser', 'no')
        })
    }




    handleValueChange(event, val) {







        let _this = this

        _this.setState({
            [event.target.name]: event.target.value,
        }, () => {




            // setTimeout(function () {
            //     _this.setState({

            //     })
            // }, 300);


            if (_this.state.pin.length <= 4) {
                this.setState({
                    toggleType1: "text"
                })




                if (_this.state.pin.length === 4) {
                    if (_this.state.confirmPin.length === 4) {

                        if (_this.state.pin === _this.state.confirmPin) {
                            _this.setState({
                                PinMatchecdError: false
                            })
                        } else {
                            _this.setState({
                                PinMatchecdError: true,

                            })
                        }
                    }
                }

            }
        })



        if (_this.state.pin.length === 4 || _this.state.pin.length >= 0) {


            _this.setState({
                pinError: false,
                // confirmPinError: false,
                // PinMatchecdError: false
                // pin: val
                // NextBtndisabled: false,

            })
        } else {
            _this.setState({
                pinError: true,
                // confirmPinError: true,
                // PinMatchecdError: true,
                // NextBtndisabled: true,

            })
        }





    }
    handleValue(val) {



        // if (pin.length <= 4 ) {
        //     
        //     this.setState({
        //         pin: val
        //     }, () => {
        //         if (this.state.pin.length === 4 ) {
        //             if (this.state.confirmPin.length === 4 ) {
        //                 
        //                 if (this.state.pin === this.state.confirmPin) {
        //                     this.setState({
        //                         PinMatchecdError: false
        //                     })
        //                 } else {
        //                     this.setState({
        //                         PinMatchecdError: true,
        //                     })
        //                 }
        //             }
        //         }
        //     }
        //     )
        // }

        if (this.state.pin.includes('_')) {


            this.setState({


                pinError: true,
                toggleType1: "text"

                // confirmPinError: false,
                // PinMatchecdError: false
                // pin: val
                // NextBtndisabled: false,

            })
        } else {
            this.setState({
                pinError: false,
                toggleType1: "password"
                // confirmPinError: true,
                // PinMatchecdError: true,
                // NextBtndisabled: true,

            })
        }




    }
    handleStatedropdown = (event, index, value) => {

        this.setState({ state: value });
    }
    handleIDStatedropdown = (event, index, value) => {

        this.setState({ state1: value });
    }
    onChangeFields(e, value) {
        const { activationcardState } = this.props

        // this.setState({
        // [e.target.name]: e.target.value
        const { name } = e.target



        this.setState({ [name]: e.target.value })

        // })
        // if (this.state.emailId === "") {
        //     this.setState({
        //         emailId: activationcardState.body && activationcardState.body.emailId
        //     }, () => {

        //     })
        // }
        // if (this.state.mobileNumber === "") {
        //     this.setState({
        //         mobileNumber: activationcardState.body && activationcardState.body.mobileNumber
        //     }, () => {

        //     })
        // }


        if (e.target.name === "firstName" || e.target.name === "lastName" || e.target.name === "userName" ||
            e.target.name === "mobileNumber" || e.target.name === "emailId" || e.target.name === "address" || e.target.name === "state" ||
            e.target.name === "pincode" || e.target.name === "password" || e.target.name === "confirmPassword" || e.target.name === "secretAnswer" || e.target.name === "password" || e.target.name === "city") {
            if (e.target.name === "firstName") {
                if (/^[a-zA-Z ]{1,20}$/.test(e.target.value)) {



                    this.setState({
                        correctFirstname: true,
                        firstName: e.target.value,
                        firstNameError: '',
                        // submitBtndisabled: false,
                    }, () => {
                        if (this.state.firstName.length >= 2) {

                            this.setState({
                                firstName: value,
                                correctFirstname: true,
                            })


                        }
                        else {
                            this.setState({
                                correctFirstname: false,
                            })
                        }
                    })


                } else {
                    this.setState({
                        correctFirstname: false,
                        firstNameError: "Not a valid name"
                        // submitBtndisabled: true,
                    })

                }
            }


            // else {
            //     this.setState({
            //         submitBtndisabled: true
            //     })
            // }
            if (e.target.name === "lastName") {
                // 
                if (/^[a-zA-Z ]{2,20}$/.test(e.target.value)) {




                    this.setState({
                        correctLastname: true,
                        lastName: e.target.value,
                        lastNameError: '',
                        // submitBtndisabled: false,
                        // }, () => {
                        //     if (this.state.firstName.length >= 6) {

                        //         this.setState({
                        //             lastName: value,
                        //             correctLastname: true,
                        //         })
                        //         
                        //         
                        //     }
                        //     else {
                        //         this.setState({
                        //             // correctLastname: false,
                        //         })
                        //     }
                    })

                } else {
                    this.setState({
                        correctLastname: false,
                        firstNameError: "Not a valid name"
                        // submitBtndisabled: true,
                    })

                }
            }

            // else {
            //     this.setState({
            //         submitBtndisabled: true
            //     })
            // }
            if (e.target.name === "userName") {

                $(function () {
                    $('#uName').on('keypress', function (e) {

                        if (e.which === 32)
                            return false;
                    });
                });

                let _this = this
                const { name } = e.target
                this.setState({ [name]: value })

                // const { userName } = this.state
                if (/^[a-zA-Z0-9]+$/.test(value)) {

                    if ((e.target.value.length) >= 6) {
                        this.props.validateUserId(value)

                        this.setState({
                            usernameVerified: true,
                            userName: value,
                            // submitBtndisabled: false,
                            validUserId: true,
                            disabledBtn: false,
                            // errorText:"",
                            // validUserName: true,
                            // submitBtndisabled: false,
                        }, () => {

                            setTimeout(function () {
                                _this.validusernameresp()
                            }, 2000)
                        })
                    }
                    else {
                        this.setState({
                            validUserId: false,
                            // errorText:"Must contain minimum 6 characters",
                            // validUserName: false,
                            // submitBtndisabled: true,
                            usernameVerified: false,
                            disabledBtn: true,

                        }, () => {

                            document.getElementById("valid1").style.display = "none"
                        })

                    }
                }
                else {
                    this.setState({
                        validUserId: false,
                        // errorText:"Must contain minimum 6 characters",
                        // validUserName: false,
                        // submitBtndisabled: true,
                        usernameVerified: false,

                    }, () => {

                        document.getElementById("valid1").style.display = "none"
                    })

                }

            }

            if (e.target.name === "mobileNumber") {

                // 
                if (/^\d{10}$/.test(e.target.value)) {





                    this.setState({
                        correctMobileNumber: true,
                        mobileNumber: e.target.value,
                        disabledBtn: false,
                        // submitBtndisabled: false,
                        // }, () => {
                        //     if (this.state.mobileNumber.length >= 8) {
                        //         this.setState({
                        //             mobileNumber: value,
                        //             correctMobileNumber: true,
                        //         })
                        //         
                        //         
                        //     }
                        //     else {
                        //         this.setState({
                        //             correctMobileNumber: false,
                        //         })
                        //     }
                    })
                } else {
                    this.setState({
                        correctMobileNumber: false,
                        disabledBtn: true,
                        mobileNumber: "",
                        // submitBtndisabled: false,: true,
                    })

                }
            }

            if (e.target.name === "emailId") {
                // eslint-disable-next-line
                if (/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,40}))$/.test(e.target.value)) {





                    // if(e.target.value === "") {
                    //     this.setState({
                    //         emailId: activationcardState.body && activationcardState.body.emailId
                    //   }, () => {
                    //     
                    //     })
                    // }
                    // 
                    this.setState({
                        correctEmail: true,
                        emailId: e.target.value,
                        // submitBtndisabled: false,: false,
                        // }, () => {
                        //     if (this.state.emailId.length >= 6) {
                        //         this.setState({
                        //             emailId: value,
                        //             correctEmail: true,
                        //         })
                        //         
                        //         
                        //     }
                        //     else {
                        //         this.setState({
                        //             correctEmail: false,
                        //         })
                        //     }
                    })

                } else {
                    this.setState({
                        correctEmail: false,
                        // submitBtndisabled: true,
                    })

                }
            }

            // else {
            //     this.setState({
            //         submitBtndisabled: true
            //     })
            // }
            if (e.target.name === "address" && e.target.value.length !== 0) {
                // eslint-disable-next-line
                if (/^[a-zA-Z,0-9,#-\/\s\!\@\$.....]{2,50}(?:[,#-\/\s\!\@\$.....][a-zA-Z]+)*$/.test(e.target.value))
                // if (e.target.value.length > 0)
                {





                    // 
                    this.setState({
                        correctAddress: true,
                        address: e.target.value,
                        // submitBtndisabled: false,
                        // }, () => {
                        //     if (this.state.address.length >= 2) {
                        //         this.setState({
                        //             address: value,
                        //             correctAddress: true,
                        //         })
                        //         
                        //         
                        //     }
                        //     else {
                        //         this.setState({
                        //             correctAddress: false,
                        //         })
                        //     }
                    })

                } else {
                    this.setState({
                        correctAddress: false,
                        // submitBtndisabled: true,
                    })

                }
            }

            // else {
            //     this.setState({
            //         submitBtndisabled: true
            //     })
            // }
            if (e.target.name === "address2" && e.target.value.length !== 0) {
                // eslint-disable-next-line
                if (/^[a-zA-Z,0-9,#-\/\s\!\@\$.....]{2,50}(?:[,#-\/\s\!\@\$.....][a-zA-Z]+)*$/.test(e.target.value)) {
                    //    if (e.target.value.length > 0) {
                    // eslint-disable-next-line
                    // 
                    this.setState({
                        // correctAddress1: true,
                        address2: e.target.value,
                        // submitBtndisabled: false,
                        // }, () => {
                        //     if (this.state.address.length >= 2) {
                        //         this.setState({
                        //             address2: value,
                        //             correctAddress1: true,
                        //         })
                        //         
                        //         
                        //     }
                        //     else {
                        //         this.setState({
                        //             correctAddress1: false,
                        //         })
                        //     }
                    })

                } else {
                    this.setState({
                        // correctAddress1: false,
                        // submitBtndisabled: true,
                    })

                }
            }

            // else {
            //     this.setState({
            //         submitBtndisabled: true
            //     })
            // }
            if (e.target.name === "city") {
                if (/^[a-zA-Z ]{2,25}$/.test(e.target.value)) {
                    // 

                    this.setState({
                        correctCity: true,
                        city: e.target.value,
                        // submitBtndisabled: false,
                        // }, () => {
                        //     if (this.state.city.length >= 2) {
                        //         this.setState({
                        //             city: value,
                        //             correctCity: true,
                        //         })
                        //         
                        //         
                        //     }
                        //     else {
                        //         this.setState({
                        //             correctCity: false,
                        //         })
                        //     }
                    })

                } else {
                    this.setState({
                        correctCity: e.target.value,
                        // submitBtndisabled: true,
                    })

                }
            }
            // else {
            //     this.setState({
            //         submitBtndisabled: true
            //     })
            // }
            if (e.target.name === "state") {

                if (/^[a-zA-Z ]{2,25}$/.test(e.target.value)) {
                    // 

                    this.setState({
                        correctState: true,
                        state: e.target.value,
                        // submitBtndisabled: false,
                        // }, () => {
                        //     if (this.state.city.length >= 2) {
                        //         this.setState({
                        //             state: value,
                        //             correctState: true,
                        //         })
                        //         
                        //         
                        //     }
                        //     else {
                        //         this.setState({
                        //             correctState: false,
                        //         })
                        //     }
                    })

                } else {
                    this.setState({
                        correctState: false,
                        // submitBtndisabled: true,
                    })

                }
            }
            // else {
            //     this.setState({
            //         submitBtndisabled: true
            //     })
            // }
            // if (e.target.name === "pincode"  ) {
            //     if (/(^\d{6}$)|(^\d{6}-\d{5}$)/.test(e.target.value)) {
            //         let addval = value.trim()

            //         var regx = /^[0-9]{6}$/
            //         if (e.target.name === "pincode" ) {

            //                 
            //             if (regx.test(addval) && (e.target.value.length >= 6) ) {
            //             
            //             this.setState({
            //                 correctPincode: true,
            //                 pincode: addval,
            //                 submitBtndisabled: false,
            //             })
            //             
            //             
            //         } else {
            //             this.setState({
            //                 correctPincode: false,
            //                 submitBtndisabled: true,
            //             })
            //             
            //             
            //         }

            // }
            if (e.target.name === "pincode") {
                if (/^\d{4,4}$/.test(e.target.value)) {

                    this.setState({
                        correctPincode: true,
                        pincode: e.target.value,
                        // submitBtndisabled: false,
                        // }, () => {
                        //     if (this.state.pincode.length >= 4) {
                        //         this.setState({
                        //             pincode: value,
                        //             correctPincode: true,
                        //         })
                        //         
                        //         
                        //     }
                        //     else {
                        //         this.setState({
                        //             correctPincode: false,
                        //         })
                        //     }
                    })

                } else {
                    this.setState({
                        correctPincode: false,
                        // submitBtndisabled: true,
                    })

                }
            }
            // else {
            //     this.setState({
            //         submitBtndisabled: true
            //     })
            // }
            if (e.target.name === "password") {
                $(function () {
                    $('#currentpasswo').on('keypress', function (e) {

                        if (e.which === 32)
                            return false;
                    });
                });
                if (/^(?=.*[0-9])(?=.*[!@#$%^&*])(?=.*[A-Z])(?=.*[a-z])[a-zA-Z0-9!@#$%^&*]{8,16}$/.test(e.target.value)) {

                    this.setState({
                        correctPassword: true,
                        password: e.target.value,
                        // submitBtndisabled: false,
                        // }, () => {
                        //     if (this.state.password.length >= 8) {
                        //         this.setState({
                        //             pincode: value,
                        //             correctPassword: true,
                        //         })
                        //         
                        //         
                        //     }
                        //     else {
                        //         this.setState({
                        //             correctPassword: false,
                        //         })
                        //     }
                    })

                } else {
                    this.setState({
                        correctPassword: false,
                        // submitBtndisabled: true,
                    })

                }

            }
            // else {
            //     this.setState({
            //         submitBtndisabled: true
            //     })
            // }
            if (e.target.name === "confirmPassword") {
                $(function () {
                    $('#confpassword').on('keypress', function (e) {

                        if (e.which === 32)
                            return false;
                    });
                });
                if (/^(?=.*[0-9])(?=.*[!@#$%^&*])(?=.*[A-Z])(?=.*[a-z])[a-zA-Z0-9!@#$%^&*]{8,16}$/.test(e.target.value)) {

                    this.setState({
                        confirmPassword: e.target.value,
                        // submitBtndisabled: false,
                    }, () => {
                        if (this.state.password === this.state.confirmPassword) {
                            this.setState({
                                correctConfirmPassword: true,
                            })


                        }
                        else {
                            this.setState({
                                correctConfirmPassword: false,
                            })
                        }
                    })

                }


                // if (this.state.password === this.state.confirmPassword) {
                //         
                //     toast.error('Password and Confirm Password should be same'), {
                //         position: "top-right",
                //         draggablePercent: 60,
                //         autoClose: 3000,
                //         hideProgressBar: false,
                //         closeOnClick: true,
                //         pauseOnHover: true,
                //         draggable: false
                //     }

                // }
            }
            // else {
            //     this.setState({
            //         submitBtndisabled: true
            //     })
            // }
            if (e.target.name === "secretAnswer") {
                if (/^[A-Za-z0-9]*[A-Za-z0-9][A-Za-z0-9]{2,15}$/.test(e.target.value)) {

                    this.setState({
                        correctAnswer: true,
                        secretPassword: e.target.value,
                        isvalidSecretAnswer: true,
                        disabledBtn: false,
                        // submitBtndisabled: false,

                        // }, () => {
                        //     if (this.state.secretAnswer.length >= 3) {
                        //         this.setState({
                        //             secretAnswer: value,
                        //             correctAnswer: true,
                        //         })
                        //         
                        //         
                        //     }
                        //     else {
                        //         this.setState({
                        //             correctAnswer: false,
                        //         })
                        //     }
                    })


                } else {
                    this.setState({
                        correctAnswer: false,
                        isvalidSecretAnswer: false,
                        disabledBtn: true,
                        secretPassword: "",
                        // submitBtndisabled: true,
                    })

                }
            }
        }
        // else {
        //     this.setState({
        //         submitBtndisabled: true
        //     })
        // }
        this.setState({
            [e.target.name]: e.target.value,
            EnableCheckbox: true,
        }, () => {
            const { firstName } = this.state
            if (this.state.firstName !== "" && firstName !== "" && this.state.countryName1 !== "" && this.state.countryName !== "" && this.state.firstName !== null && this.state.validUserName === true && this.state.lastName !== "" && this.state.lastName !== null && this.state.userName !== "" && this.state.userName !== null && this.state.mobileNumber !== "" && this.state.mobileNumber !== null && this.state.address !== "" && this.state.address !== null && this.state.city !== "" && this.state.city !== null && this.state.state !== "" && this.state.state !== null && this.state.pincode !== "" && this.state.pincode !== null && this.state.password !== "" && this.state.password !== null && this.state.confirmPassword !== "" && this.state.confirmPassword !== null && this.state.emailId !== null && this.state.secretAnswer !== ""
                && this.state.streetNumber !== "" && this.state.state1 !== "" && this.state.idNumber !== "" && this.state.dateofbirth !== "" && this.state.correctFirstname === true && this.state.correctLastname === true && this.state.correctUsername === true && this.state.correctMobileNumber === true && this.state.correctPassword === true && this.state.correctAddress === true && this.state.correctAnswer === true && this.state.correctEmail === true && this.state.correctCity === true && this.state.correctState === true && this.state.correctPincode === true && this.state.correctPassword === true && this.state.correctConfirmPassword === true && this.state.correctEmail === true && this.state.KycConsent === true) {
                this.setState({
                    // stepIndex: 2,
                    submitBtndisabled: false
                })

            }
            else {
                this.setState({
                    submitBtndisabled: true
                })
            }
        })
    }


    handleValueConfirm(val) {





        if (this.state.confirmPin.includes("_")) {


            this.setState({
                toggleText: "text",
                confirmPinError: true,

                // PinMatchecdError: false
                // pin: val
                // NextBtndisabled: false,

            })
        } else {
            this.setState({
                // pinError: true,


                toggleText: "password",
                confirmPinError: false,
                // PinMatchecdError: true,
                // NextBtndisabled: true,

            })
        }




    }



    handleValueChangeconfirm(e, val) {


        let _this = this
        _this.setState({
            confirmPin: e.target.value,
        }, () => {


            if (_this.state.confirmPin.length <= 4) {
                this.setState({
                    toggleText: "text"
                })

                if (_this.state.confirmPin.length <= 4) {
                    if (_this.state.pin.length === 4) {
                        if (_this.state.confirmPin.length === 4) {
                            if (_this.state.pin === _this.state.confirmPin) {
                                _this.setState({
                                    PinMatchecdError: false
                                })
                            } else {
                                _this.setState({
                                    PinMatchecdError: true,
                                })
                            }
                        }
                    }
                }
            }
        })



        // if (_this.state.confirmPin.length === 4 ) {
        //     
        //     


        //     _this.setState({
        //         confirmPinError: false,
        //     })
        // } else {
        //     _this.setState({
        //         confirmPinError: true,
        //     })
        // }
    }


    handleValueChangenext(val) {
        if (val.length <= 4) {
            this.setState({ pin: val });
        }
    }
    handleValueChangeconfirmnext(val) {

        if (val.length <= 4) {
            this.setState({ confirmPin: val });
        }
    }
    checkObject(obj) {
        for (var prop in obj) {
            if (obj.hasOwnProperty(prop)) {
                return true;
            } else {
                return false
            }
        }
    }
    handleFocusUser = () => {
        if (document.getElementById("valid1").style.display = "block") {
            document.getElementById("valid1").style.display = "none"
        }
        if (document.getElementById("invalid1").style.display = "block") {
            document.getElementById("invalid1").style.display = "none"
        }
    }




    validusernameresp = () => {
        const { validUserIdState } = this.props
        if ((this.state.userName.length) >= 6) {

            if (validUserIdState.status === 200 && validUserIdState.body.userIdAvailable === true) {

                this.setState({
                    usernameVerified: false,
                    validUserName: true,
                    correctUsername: true,
                    validUser: true,
                }, () => {

                    document.getElementById("invalid1").style.display = "none"
                    document.getElementById("valid1").style.display = "block"





                    //     if (this.state.firstName !== "" && this.state.firstName !== null && this.state.lastName !== "" && this.state.lastName !== null && this.state.userName !== "" && this.state.userName !== null && this.state.mobileNumber !== "" && this.state.mobileNumber !== null && this.state.address !== "" && this.state.address !== null && this.state.address2 !== "" && this.state.address2 !== null && this.state.city !== "" && this.state.city !== null && this.state.state !== "" && this.state.state !== null && this.state.pincode !== "" && this.state.pincode !== null && this.state.password !== "" && this.state.confirmPassword !== "" && this.state.emailId !== null && this.state.secretAnswer !== "" && this.state.gender !== "" && this.state.dateofbirth !== "" && this.state.correctUsername === true) {
                    //         this.setState({
                    //             submitBtndisabled: false
                    //         })
                    //     }
                    //     else {
                    //         this.setState({
                    //             submitBtndisabled: true,
                    //             // validUserName: false,
                    //         })
                    //     }
                })
            }
            else {
                this.setState({
                    usernameVerified: false,
                    validUserName: false,
                    correctUsername: false,
                    validUser: false,
                    // errorText:"User already exists!",
                    // submitBtndisabled: true

                }, () => {

                    document.getElementById("valid1").style.display = "none"

                    document.getElementById("invalid1").style.display = "block"





                    //    document.getElementById("myModal").style.display = "block"


                })
            }
        }
    }
    handleClose = () => {
        if (document.getElementById("username") !== null) {

            document.getElementById("username").value = ""
            document.getElementById("username").focus()
        }
        document.getElementById("invalid1").style.display = "none"
        document.getElementById("myModal").style.display = "none"


    }



    checkUserName = () => {

    }
    // handleGender = (event, index, value1) => {
    //     if (value1 !== null) {
    //         this.setState({
    //             gender: value1,
    //             genderSelected: true
    //         }, () => {

    //             const { correctPassword } = this.state

    //             const { firstName, lastName, gender, dateofbirth, mobileNumber, validUser, emailId, address, address2, city, pincode, userName, password, email, confirmPassword, state, secretAnswer } = this.state
    //             const { correctFirstname, correctLastname, correctUsername, validUserName, correctAddress,  correctAnswer, correctEmail, correctCity, correctState, correctPincode, correctConfirmPassword, correctMobileNumber } = this.state

    //             if (this.state.firstName !== "" && this.state.firstname !== null && this.state.lastName !== "" && this.state.validUserName === false && this.state.lastName !== null && this.state.userName !== "" && this.state.userName !== null && this.state.mobileNumber !== "" && this.state.mobileNumber !== null && this.state.address !== "" && this.state.address !== null && this.state.address2 !== "" && this.state.address2 !== null && this.state.city !== "" && this.state.city !== null && this.state.state !== "" && this.state.state !== null && this.state.pincode !== "" && this.state.pincode !== null && this.state.password !== "" && this.state.password !== null && this.state.confirmPassword !== "" && this.state.confirmPassword !== null && this.state.emailId !== null && this.state.secretAnswer !== ""
    //                 && correctFirstname == true && correctLastname === true && correctUsername === true && correctMobileNumber === true && correctPassword === true && correctAddress === true &&  correctAnswer === true && correctEmail === true && correctCity === true && correctState === true && correctPincode === true && correctPassword === true && correctConfirmPassword === true && correctEmail === true && this.state.validUserName === true) {

    //                 this.setState({
    //                     // stepIndex: 2,
    //                     submitBtndisabled: false
    //                 })
    //                 // 
    //             }
    //             else {
    //                 // 
    //                 // 
    //                 this.setState({
    //                     submitBtndisabled: true
    //                 })
    //             }
    //         });
    //     }
    // else {
    //     this.setState({
    //         gender: "",
    //         disabled: true
    //     })
    // }
    // }
    converDate(date) {
        var mm = date.getMonth() + 1; // getMonth() is zero-based
        var dd = date.getDate();

        return [date.getFullYear(),
        (mm > 9 ? '' : '0') + mm,
        (dd > 9 ? '' : '0') + dd
        ].join('-');
    }
    converSelectedDate(date) {
        var mm = date.getMonth() + 1; // getMonth() is zero-based
        var dd = date.getDate();

        return [(dd > 9 ? '' : '0') + dd,
        (mm > 9 ? '' : '0') + mm,
        date.getFullYear(),].join('/');
    }
    formatDate = (date) => {

        let day = date.getDate()
        let month = date.getMonth() + 1
        let year = date.getFullYear()
        return `${(day < 10) ? ('0' + day) : day}/${(month < 10) ? ('0' + month) : month}/${year}`
    }

    handleExpiry(e) {

        let exp_Date = e.target.value
        console.log(exp_Date)
        let expDate = ""
        let expDate1 = ""

        if (moment(exp_Date, "DD/MM/YYYY", true).isValid()) {
            const split = exp_Date.split('/');
            let day = split[0];
            let month = split[1];
            let year = split[2];

            expDate = `${year}-${month}-${day}`;
            expDate1 = `${day}${month}-${year}`;

            this.setState({
                isvalidExpiry: true,
            })

        } else {

            this.setState({
                isvalidExpiry: false,
            })
        }

        this.setState({
            idExpiry: e.target.value,
            idExpiry1: expDate
        }, () => {

            console.log(this.state.idExpiry)
            console.log(this.state.idExpiry1)
            const { correctPassword } = this.state


            const { correctDateofbirth, correctFirstname, correctLastname, correctUsername, correctAddress, correctAnswer, correctEmail, correctCity, correctState, correctPincode, correctConfirmPassword, correctMobileNumber } = this.state

            if (this.state.firstName !== "" && this.state.countryName1 !== "" && this.state.countryName !== "" && this.state.firstName !== null && this.state.validUserName === true && this.state.lastName !== "" && this.state.lastName !== null && this.state.userName !== "" && this.state.userName !== null && this.state.mobileNumber !== "" && this.state.mobileNumber !== null && this.state.address !== "" && this.state.address !== null && this.state.city !== "" && this.state.city !== null && this.state.state !== "" && this.state.state !== null && this.state.pincode !== "" && this.state.pincode !== null && this.state.password !== "" && this.state.password !== null && this.state.confirmPassword !== "" && this.state.confirmPassword !== null && this.state.emailId !== null && this.state.secretAnswer !== ""
                && this.state.streetNumber !== "" && this.state.state1 !== "" && this.state.idNumber !== "" && this.state.isvalidDOB === true && this.state.isvalidExpiry === true && this.state.correctFirstname === true && this.state.correctLastname === true && this.state.correctUsername === true && this.state.correctMobileNumber === true && this.state.correctPassword === true && this.state.correctAddress === true && this.state.correctAnswer === true && this.state.correctEmail === true && this.state.correctCity === true && this.state.correctState === true && this.state.correctPincode === true && this.state.correctPassword === true && this.state.correctConfirmPassword === true && this.state.correctEmail === true && this.state.KycConsent === true) {

                this.setState({

                    submitBtndisabled: false,

                })

            }
            else {

                this.setState({
                    submitBtndisabled: true,

                })
            }
        })


    }

    handleDateOfBirth(e) {
        //let valid_date = new Date(e.target.value)
        let valid_date = e.target.value


        if (moment(valid_date, "DD/MM/YYYY", true).isValid()) {
            const split = valid_date.split('/');
            let day = split[0];
            let month = split[1];
            let year = split[2];

            console.log('day', split[0])
            console.log('month', split[1])
            console.log('year', split[2])

            //console.log("fulldate in yyyy-mm-dd" , [year, month, day].join('-') );
            //console.log("fulldate in dd-mm-yyyy" , [day, month, year].join('-') );
            //let formattedDate_dmy = [day, month, year].join('');


            let finalDate = `${year}-${month}-${day}`;

            //let newdate =  moment(formattedDate_dmy, "dd-mm-yyyy");
            //console.log( " newdate " , newdate)
            //let formattedDate = new Date().toLocaleDateString(new Date(newdate), "dd-mm-yyyy")

            //console.log("newdates month " , newdate.month()+1);

            console.log("Formattted dmy ", finalDate);
            this.setState({
                dateofbirth: finalDate,
                //dob: this.converSelectedDate(date),
                dob: `${day}/${month}/${year}`,
                dateSelected: true,
                correctDateofbirth: true,
                isvalidDOB: true,
            }, function () {
                //console.log("Date of Birth Final " , this.state.dateofbirth);
                const { correctPassword } = this.state


                const { correctDateofbirth, correctFirstname, correctLastname, correctUsername, correctAddress, correctAnswer, correctEmail, correctCity, correctState, correctPincode, correctConfirmPassword, correctMobileNumber } = this.state

                if (this.state.firstName !== "" && this.state.countryName1 !== "" && this.state.countryName !== "" && this.state.firstName !== null && this.state.validUserName === true && this.state.lastName !== "" && this.state.lastName !== null && this.state.userName !== "" && this.state.userName !== null && this.state.mobileNumber !== "" && this.state.mobileNumber !== null && this.state.address !== "" && this.state.address !== null && this.state.city !== "" && this.state.city !== null && this.state.state !== "" && this.state.state !== null && this.state.pincode !== "" && this.state.pincode !== null && this.state.password !== "" && this.state.password !== null && this.state.confirmPassword !== "" && this.state.confirmPassword !== null && this.state.emailId !== null && this.state.isvalidSecretAnswer === true && this.state.isvalidExpiry
                    && this.state.streetNumber !== "" && this.state.state1 !== "" && this.state.idNumber !== "" && this.state.isvalidDOB === true && this.state.correctFirstname === true && this.state.correctLastname === true && this.state.correctUsername === true && this.state.correctMobileNumber === true && this.state.correctPassword === true && this.state.correctAddress === true && this.state.correctAnswer === true && this.state.correctEmail === true && this.state.correctCity === true && this.state.correctState === true && this.state.correctPincode === true && this.state.correctPassword === true && this.state.correctConfirmPassword === true && this.state.correctEmail === true && this.state.KycConsent === true) {

                    this.setState({
                        // stepIndex: 2,
                        submitBtndisabled: false,

                    })
                    // 
                }
                else {
                    // 
                    // 
                    this.setState({
                        submitBtndisabled: true,

                    })
                }
            });

            if (this.state.dateofbirth !== "") {
                this.setState({
                    correctDateofbirth: true
                })
            } else {
                this.setState({
                    correctDateofbirth: false
                })
            }

        } else {
            this.setState({
                isvalidDOB: false,
            }, function () {
                //console.log("Date of Birth Final " , this.state.dateofbirth);
                const { correctPassword } = this.state


                const { correctDateofbirth, correctFirstname, correctLastname, correctUsername, correctAddress, correctAnswer, correctEmail, correctCity, correctState, correctPincode, correctConfirmPassword, correctMobileNumber } = this.state

                if (this.state.firstName !== "" && this.state.countryName1 !== "" && this.state.countryName !== "" && this.state.firstName !== null && this.state.validUserName === true && this.state.lastName !== "" && this.state.lastName !== null && this.state.userName !== "" && this.state.userName !== null && this.state.mobileNumber !== "" && this.state.mobileNumber !== null && this.state.address !== "" && this.state.address !== null && this.state.city !== "" && this.state.city !== null && this.state.state !== "" && this.state.state !== null && this.state.pincode !== "" && this.state.pincode !== null && this.state.password !== "" && this.state.password !== null && this.state.confirmPassword !== "" && this.state.confirmPassword !== null && this.state.emailId !== null && this.state.isvalidSecretAnswer === true && this.state.isvalidExpiry
                    && this.state.streetNumber !== "" && this.state.state1 !== "" && this.state.idNumber !== "" && this.state.isvalidDOB === true && this.state.correctFirstname === true && this.state.correctLastname === true && this.state.correctUsername === true && this.state.correctMobileNumber === true && this.state.correctPassword === true && this.state.correctAddress === true && this.state.correctAnswer === true && this.state.correctEmail === true && this.state.correctCity === true && this.state.correctState === true && this.state.correctPincode === true && this.state.correctPassword === true && this.state.correctConfirmPassword === true && this.state.correctEmail === true && this.state.KycConsent === true) {

                    this.setState({
                        // stepIndex: 2,
                        submitBtndisabled: false,

                    })
                    // 
                }
                else {
                    // 
                    // 
                    this.setState({
                        submitBtndisabled: true,

                    })
                }
            });
        }
    }
    handleDate = (e, date) => {
        // var dob1 = new Date(date);
        // var ISostring = dob1.toISOString();
        this.setState({
            // dateofbirth: ISostring,
            dateofbirth: this.converDate(date),
            dob: this.converSelectedDate(date),
            dateSelected: true,
            correctDateofbirth: true,

        }, () => {

            const { correctPassword } = this.state


            const { correctDateofbirth, correctFirstname, correctLastname, correctUsername, correctAddress, correctAnswer, correctEmail, correctCity, correctState, correctPincode, correctConfirmPassword, correctMobileNumber } = this.state

            if (this.state.firstName !== "" && this.state.countryName1 !== "" && this.state.countryName !== "" && this.state.firstName !== null && this.state.validUserName === true && this.state.lastName !== "" && this.state.lastName !== null && this.state.userName !== "" && this.state.userName !== null && this.state.mobileNumber !== "" && this.state.mobileNumber !== null && this.state.address !== "" && this.state.address !== null && this.state.city !== "" && this.state.city !== null && this.state.state !== "" && this.state.state !== null && this.state.pincode !== "" && this.state.pincode !== null && this.state.password !== "" && this.state.password !== null && this.state.confirmPassword !== "" && this.state.confirmPassword !== null && this.state.emailId !== null && this.state.secretAnswer !== ""
                && this.state.streetNumber !== "" && this.state.state1 !== "" && this.state.idNumber !== "" && this.state.dateofbirth !== "" && this.state.correctFirstname === true && this.state.correctLastname === true && this.state.correctUsername === true && this.state.correctMobileNumber === true && this.state.correctPassword === true && this.state.correctAddress === true && this.state.correctAnswer === true && this.state.correctEmail === true && this.state.correctCity === true && this.state.correctState === true && this.state.correctPincode === true && this.state.correctPassword === true && this.state.correctConfirmPassword === true && this.state.correctEmail === true && this.state.KycConsent === true) {

                this.setState({
                    // stepIndex: 2,
                    submitBtndisabled: false,

                })
                // 
            }
            else {
                // 
                // 
                this.setState({
                    submitBtndisabled: true,

                })
            }
        });
        if (this.state.dateofbirth !== "") {
            this.setState({
                correctDateofbirth: true
            })
        } else {
            this.setState({
                correctDateofbirth: false
            })
        }

    }

    handleSecretDate(e) {



        let sec_date = e.target.value
        console.log(sec_date)
        let secrteDate = ""
        let secrteDate1 = ""

        if (moment(sec_date, "DD/MM/YYYY", true).isValid()) {
            const split = sec_date.split('/');
            let day = split[0];
            let month = split[1];
            let year = split[2];

            secrteDate = `${year}-${month}-${day}`;
            secrteDate1 = `${day}/${month}/${year}`;
            this.setState({
                isvalidSecretAnswer: true,
                disabledBtn: false,
            })
        } else {
            this.setState({
                isvalidSecretAnswer: false
            })
        }

        this.setState({
            //secretAnswerDate: secrteDate,
            secretAnswer: e.target.value,
            secretPassword: secrteDate,
            //secretPassword: this.converDate(date),
            secretPasswordDate: secrteDate1,
            // secretPasswordDate: finalDate,
            dateSelect: true,
        }, function () {
            console.log(this.state.secretAnswer)
            console.log(this.state.secretPassword)
            console.log(this.state.secretPasswordDate)

            const { correctPassword } = this.state

            const { correctFirstname, correctLastname, correctUsername, correctAddress, correctAnswer, correctEmail, correctCity, correctState, correctPincode, correctConfirmPassword, correctMobileNumber } = this.state
            if (this.state.userName !== "" && this.state.userName !== null && this.state.mobileNumber !== "" && this.state.mobileNumber !== null && this.state.password !== "" && this.state.password !== null && this.state.confirmPassword !== "" && this.state.confirmPassword !== null && this.state.emailId !== null && this.state.isvalidSecretAnswer === true
                && this.state.correctPassword === true && this.state.correctAnswer === true && this.state.correctEmail === true && this.state.correctPassword === true && this.state.correctConfirmPassword === true && this.state.correctEmail === true) {
                this.setState({
                    disabledBtn: false,
                })
            }

            if (this.state.firstName !== "" && this.state.countryName1 !== "" && this.state.countryName !== "" && this.state.firstName !== null && this.state.validUserName === true && this.state.lastName !== "" && this.state.lastName !== null && this.state.userName !== "" && this.state.userName !== null && this.state.mobileNumber !== "" && this.state.mobileNumber !== null && this.state.address !== "" && this.state.address !== null && this.state.city !== "" && this.state.city !== null && this.state.state !== "" && this.state.state !== null && this.state.pincode !== "" && this.state.pincode !== null && this.state.password !== "" && this.state.password !== null && this.state.confirmPassword !== "" && this.state.confirmPassword !== null && this.state.emailId !== null && this.state.isvalidSecretAnswer === true
                && this.state.streetNumber !== "" && this.state.state1 !== "" && this.state.idNumber !== "" && this.state.isvalidDOB === true && this.state.correctFirstname === true && this.state.correctLastname === true && this.state.correctUsername === true && this.state.correctMobileNumber === true && this.state.correctPassword === true && this.state.correctAddress === true && this.state.correctAnswer === true && this.state.correctEmail === true && this.state.correctCity === true && this.state.correctState === true && this.state.correctPincode === true && this.state.correctPassword === true && this.state.correctConfirmPassword === true && this.state.correctEmail === true && this.state.KycConsent === true) {

                this.setState({
                    // stepIndex: 2,
                    submitBtndisabled: false,
                    disabledBtn: false,
                })
                // 
            }
            else {
                // 
                // 
                this.setState({
                    submitBtndisabled: true,
                    disabledBtn: true,
                })
            }
        })

        if (this.state.secretPasswordDate !== "") {
            this.setState({
                correctAnswerDate: true
            })
        } else {
            this.setState({
                correctAnswerDate: false
            })
        }

    }




    onEnterPress = (e) => {
        if (e.keyCode === 13 && e.shiftKey === false) {
            e.preventDefault();
            this.handleLogin();
        }
    }

    handelvalidateusername = (e, value) => {
        if (e.target.name === "userName" && value.length !== 0) {
            if (/^[a-zA-Z-, ]+([a-zA-Z-,0-9 ])+([0-9])*$/.test(e.target.value)) {

                this.setState({
                    userName: value || this.state.userName,
                    correctUsername: true,

                }, () => {
                    // document.getElementById("valid1").style.display = "none"
                    // document.getElementById("invalid1").style.display = "none"
                })
            } else {
                this.setState({
                    correctUsername: false,

                })
            }
        } else {
            this.setState({
                [e.target.name]: e.target.value
            }, () => {


            })
        }
    }
    handelvalidateexistingusername = (e, value) => {
        if (e.target.name === "userName" && value.length !== 0) {
            // if ((e.target.value.length) >= 6) {
            this.setState({
                userName: value
            }, () => {
                if (this.state.userName.length !== 0 && this.state.password.length !== 0) {
                    this.setState({
                        disabled: false
                    })
                } else {
                    this.setState({
                        disabled: true
                    })
                }
            })
            // }else {
            //     this.setState({
            //         correctUsername: false
            //     })
            // }
        } else {
            this.setState({
                disabled: true
            })
        }
    }
    handlemcountryempty = (e) => {

        const { name, term } = e.target
        this.setState({ [name]: e.target.value })


        if (e.target.value.length !== 0) {
            this.setState({
                countryName: term,
                countryCode: e.target.value,
            })

        }
        if (this.state.firstName !== "" && this.state.countryName1 !== "" && this.state.countryName !== "" && this.state.firstName !== null && this.state.validUserName === true && this.state.lastName !== "" && this.state.lastName !== null && this.state.userName !== "" && this.state.userName !== null && this.state.mobileNumber !== "" && this.state.mobileNumber !== null && this.state.address !== "" && this.state.address !== null && this.state.city !== "" && this.state.city !== null && this.state.state !== "" && this.state.state !== null && this.state.pincode !== "" && this.state.pincode !== null && this.state.password !== "" && this.state.password !== null && this.state.confirmPassword !== "" && this.state.confirmPassword !== null && this.state.emailId !== null && this.state.secretAnswer !== ""
            && this.state.streetNumber !== "" && this.state.state1 !== "" && this.state.idNumber !== "" && this.state.dateofbirth !== "" && this.state.correctFirstname === true && this.state.correctLastname === true && this.state.correctUsername === true && this.state.correctMobileNumber === true && this.state.correctPassword === true && this.state.correctAddress === true && this.state.correctAnswer === true && this.state.correctEmail === true && this.state.correctCity === true && this.state.correctState === true && this.state.correctPincode === true && this.state.correctPassword === true && this.state.correctConfirmPassword === true && this.state.correctEmail === true && this.state.KycConsent === true) {


            this.setState({
                // stepIndex: 2,
                submitBtndisabled: false
            })

        }
        else {


            this.setState({
                submitBtndisabled: true
            })
        }
        // 
    }
    handlemcountryIdDocument = (e) => {

        const { name, term } = e.target





        // this.setState({ [name]: e.target.value })


        if (e.target.value.length !== 0) {
            this.setState({
                // countryName1: e.target.value,
                countryName1: e.target.value,

                countryCode1: term,
            }, () => {

                if (this.state.firstName !== "" && this.state.countryName1 !== "" && this.state.countryName !== "" && this.state.firstName !== null && this.state.validUserName === true && this.state.lastName !== "" && this.state.lastName !== null && this.state.userName !== "" && this.state.userName !== null && this.state.mobileNumber !== "" && this.state.mobileNumber !== null && this.state.address !== "" && this.state.address !== null && this.state.city !== "" && this.state.city !== null && this.state.state !== "" && this.state.state !== null && this.state.pincode !== "" && this.state.pincode !== null && this.state.password !== "" && this.state.password !== null && this.state.confirmPassword !== "" && this.state.confirmPassword !== null && this.state.emailId !== null && this.state.secretAnswer !== ""
                    && this.state.streetNumber !== "" && this.state.state1 !== "" && this.state.idNumber !== "" && this.state.dateofbirth !== "" && this.state.correctFirstname === true && this.state.correctLastname === true && this.state.correctUsername === true && this.state.correctMobileNumber === true && this.state.correctPassword === true && this.state.correctAddress === true && this.state.correctAnswer === true && this.state.correctEmail === true && this.state.correctCity === true && this.state.correctState === true && this.state.correctPincode === true && this.state.correctPassword === true && this.state.correctConfirmPassword === true && this.state.correctEmail === true && this.state.KycConsent === true) {



                    this.setState({
                        // stepIndex: 2,
                        submitBtndisabled: false
                    })

                }
                else {


                    this.setState({
                        submitBtndisabled: true
                    })
                }
            })
        }
        // 
    }

    handelvalidatepassword = (e, value) => {
        if (e.target.name === "password" && value.length !== 0) {
            // if ((e.target.value.length) >= 8) {
            this.setState({
                password: value
            }, () => {
                if (this.state.userName.length !== 0 && this.state.password.length !== 0) {
                    this.setState({
                        disabled: false
                    })
                } else {
                    this.setState({
                        disabled: true
                    })
                }
            })
            // }else {
            //     this.setState({
            //         correctPassword: false
            //     })
            // }
        } else {
            this.setState({
                disabled: true
            })
        }
    }

    verifyCallback = response => {
        // 

        this.setState({
            response: response
        }, () => {
            if (this.state.response.length !== 0) {
                this.setState({
                    verifyBtndisabled: false
                })
            }
            else {
                this.setState({
                    verifyBtndisabled: true
                })
            }
        })
    }
    expiredCallback = response => {
        this.setState({
            verifyBtndisabled: true
        })

    }



    getStepContent(stepIndex) {
        //debugger;
        // let cardtype = localStorage.getItem('cardTypes')
        // const baseCardType = cardtype && cardtype.replace(/D$/, ''); // "RD" -> "R", "R" -> "R"
        let cardtype = localStorage.getItem('cardTypes') || localStorage.getItem('cardType')
        const baseCardType = cardtype && cardtype.replace(/D$/, '');
        if (baseCardType === "G" || baseCardType === "R" || baseCardType === "A") {
            switch (stepIndex) {
                case 0:
                    const { pinError, confirmPinError, expiryError, PinMatchecdError } = this.state;
                    const msg = "PIN must be 4 numbers"
                    const msg1 = "Invalid Expiry Date"
                    const msg2 = "PIN and confirm PIN do not match"
                    const errorDiv = <div className="pl-0 simsfont col-sm-12 " style={{ marginTop: 10, color: "#d64a4a", fontSize: "13px" }}>
                        {msg}
                    </div>
                    const errorDiv1 = <div className="pl-0 simsfont col-sm-12 " style={{ marginTop: -15, color: "#d64a4a", fontSize: "13px" }}>
                        {msg1}
                    </div>
                    const errorDiv2 = <div className="pl-0 simsfont col-sm-12 " style={{ marginTop: 10, color: "#d64a4a", fontSize: "13px" }}>
                        {msg2}

                    </div>

                    return (
                        <div className="row">
                            <div className="col-md-12 p-0 m-0" style={{ marginTop: "20px" }}>
                                <h4 className='logmainheading mainheading'>
                                    Personal Identification Number
                                </h4>

                                <p>
                                    Please choose your personal identification number (PIN). You will need to enter this PIN when prompted by the merchant when using your card. You can change your PIN at any time from the Additional Services menu. Enter a 4 digit number.
                                </p>
                            </div>

                            <div className="col-md-4 ">
                                <div className="row input-group" >
                                    <div className="col-sm-10">
                                        <div className="group">
                                            <InputMask mask="9999" maskchar="*" type={this.state.toggleType1} value={this.state.pin} name="pin" onChange={(event, value) => { this.handleValueChange(event, value) }}
                                                onBlur={(value) => { this.handleValue(value); }} />
                                            <span className="highlight"></span>
                                            <span className="bar"></span>
                                            <label className='simsfont'>PIN</label>
                                        </div>
                                        <span toggle="#pin" className={`${this.state.togglePINIcon} field-icon toggle-password`} style={{ float: "right", right: "10px", position: "absolute", top: "40px", cursor: "pointer" }} onClick={this.togglePIN} ></span>
                                        {pinError && errorDiv}
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-4">
                                <div className="row input-group" >
                                    <div className="col-sm-10">
                                        <div className="group" >
                                            <InputMask mask="9999" maskchar="*" type={this.state.toggleText} value={this.state.confirmPin} name="confirmPin" onChange={(e, value) => { this.handleValueChangeconfirm(e, value); }}
                                                onBlur={(e, value) => { this.handleValueConfirm(e, value); }} />
                                            <span className="highlight"></span>
                                            <span className="bar"></span>
                                            <label className='simsfont'>Confirm PIN</label>
                                        </div>
                                        <span toggle="#cofirmpin" className={`${this.state.toggleConfirmPINIcon} field-icon toggle-password`} style={{ float: "right", right: "10px", position: "absolute", top: "40px", cursor: "pointer" }} onClick={this.toggleConfirmPIN} ></span>
                                        {confirmPinError && errorDiv}
                                        {PinMatchecdError && errorDiv2}
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-4">
                                <div className="row input-group">
                                    <div className="col-sm-10">
                                        <div className="group" >
                                            <InputMask mask="99/99" placeholder="MM/YY" name="expiry" onChange={(e, value) => { this.onChange(e, value) }} />
                                            <span className="highlight"></span>
                                            <span className="bar"></span>
                                            <label className='simsfont'>Card Expiry Date</label>
                                        </div>
                                        {expiryError && errorDiv1}
                                    </div>
                                </div>
                            </div>
                        </div>
                    );

                case 1:
                    if ((this.state.existingUser === "no" || this.state.existingUser === "false") || localStorage.getItem('existingUser') === "false") {
                        //debugger;
                        // const { secretQues, activationcardState } = this.props
                        // const { parsedErrors, Data, correctAddress, correctCity, correctState, correctPincode, correctDateofbirth, correctFirstname, correctLastname, correctAnswerDate, correctMobileNumber, correctEmail, usernameVerified, correctConfirmPassword, correctPassword, correctAnswer } = this.state
                        // let cardtype = localStorage.getItem('cardTypes')
                        // const baseCardType = cardtype && cardtype.replace(/D$/, '');
                        const { secretQues, activationcardState } = this.props
                        const { parsedErrors, Data, correctAddress, correctCity, correctState, correctPincode, correctDateofbirth, correctFirstname, correctLastname, correctAnswerDate, correctMobileNumber, correctEmail, usernameVerified, correctConfirmPassword, correctPassword, correctAnswer } = this.state
                        let cardtype = localStorage.getItem('cardTypes') || localStorage.getItem('cardType')
                        const baseCardType = cardtype && cardtype.replace(/D$/, '');

                        return (
                            <div className="row">
                                {baseCardType === "A" &&
                                    <div className="offset-sm-2 col-sm-7">
                                        <div className="row">
                                            <div className="button offset-sm-1 col-sm-4" style={{ textAlign: "center" }}>
                                                <RaisedButton
                                                    label="Quick Balance"
                                                    onClick={this.handleBalanceCheck.bind(this)}
                                                    style={styles.button}
                                                    className="btn-std"
                                                    backgroundColor="#FFCE39"
                                                    labelColor="#115876"
                                                />
                                            </div>
                                            {this.state.loader1 === true ?
                                                <div className="col-sm-1" style={{ marginTop: "-30px", marginLeft: "30px", width: "30% !mportant" }} >
                                                    <LoaderSmall />
                                                </div>
                                                :
                                                <div className="col-sm-3">
                                                    {this.state.balance !== "" ?
                                                        <div className="balance simsfont" style={{ fontSize: "16px", fontWeight: "600", marginTop: "5px" }}>
                                                            Balance: {"" + this.state.balance}
                                                        </div>
                                                        :
                                                        null}
                                                </div>
                                            }
                                        </div>
                                    </div>
                                }

                                {(baseCardType === "A" || baseCardType === "R" || baseCardType === "G") ? (
                                    <div className="col-sm-12 ">
                                        <div className="row">
                                            <div className="col-md-12" style={{ marginTop: "15px" }}>
                                                <div className="row">
                                                    <h4 className='logmainheading mainheading'>
                                                        Personal Information
                                                    </h4>
                                                </div>
                                            </div>


                                            <div className="col-sm-12 ">
                                                <div className="row">

                                                    <div className="col-sm-4 nopadding">
                                                        <div className="row input-group" >

                                                            <div className="col-sm-10" style={{ paddingRight: "0px" }}>

                                                                <TextField
                                                                    hintText="Start Typing"
                                                                    floatingLabelText="Email"
                                                                    name="emailId"
                                                                    maxLength="50"
                                                                    autoComplete='none'
                                                                    className="input-width required simsfont"
                                                                    shrink={true}
                                                                    onPaste={(e) => {
                                                                        e.persist();
                                                                        setTimeout(() => {
                                                                            this.setState({
                                                                                emailId: e.target.value,
                                                                                correctEmail: true
                                                                            })
                                                                        }, 500)
                                                                    }
                                                                    }
                                                                    onChange={this.onChangeFields.bind(this)}
                                                                    value={this.state.emailId}
                                                                    onBlur={this.handleVerifyFilled}
                                                                    underlineFocusStyle={styles.focusStyle}
                                                                    floatingLabelFocusStyle={styles.focusTextStyle}
                                                                    errorText={correctEmail ? null : "Not a valid emailId"}

                                                                />
                                                            </div>
                                                        </div>

                                                    </div>


                                                    <div className="col-sm-4 nopadding">
                                                        <div className="row input-group" >

                                                            <div className="col-sm-10" style={{ paddingRight: "0px" }}>

                                                                <TextField
                                                                    hintText="Start Typing"
                                                                    floatingLabelText="Mobile Number"
                                                                    name="mobileNumber"
                                                                    type="text"
                                                                    autoComplete='none'
                                                                    maxLength="20"
                                                                    shrink={true}
                                                                    onChange={this.onChangeFields.bind(this)}
                                                                    value={this.state.mobileNumber}
                                                                    onBlur={this.handleVerifyFilled}
                                                                    className="input-width required simsfont"
                                                                    underlineFocusStyle={styles.focusStyle}
                                                                    floatingLabelFocusStyle={styles.focusTextStyle}
                                                                    errorText={correctMobileNumber ? null : "Not a valid mobile number"}
                                                                />
                                                            </div>
                                                        </div>

                                                    </div>

                                                </div>
                                            </div>

                                            <div className="col-sm-12 ">
                                                <div className="row">

                                                    <div className="col-sm-4 nopadding">
                                                        <div className="row input-group" >

                                                            <div className="col-sm-10" style={{ paddingRight: "0px" }}>

                                                                <TextField
                                                                    hintText="Typing"
                                                                    floatingLabelText="User ID"
                                                                    type="text"
                                                                    name="userName"
                                                                    autoComplete='off'
                                                                    maxLength="20"
                                                                    minLength="1"
                                                                    autoFocus={this.state.autoFocus}
                                                                    value={this.state.userName}
                                                                    onPaste={(e) => {
                                                                        e.persist();
                                                                        setTimeout(() => { this.onChangeFields.bind(this) }, 4)
                                                                    }
                                                                    }
                                                                    onChange={this.onChangeFields.bind(this)}
                                                                    onBlur={this.handleVerifyFilled}
                                                                    onFocus={this.handleFocusUser}
                                                                    className="input-width required simsfont"
                                                                    id="uName"
                                                                    underlineFocusStyle={styles.focusStyle}
                                                                    floatingLabelFocusStyle={styles.focusTextStyle}
                                                                    errorText={this.state.validUserId === true ? this.state.validUserName === true ? null : "User ID Already Exists!" : " Must contain a minimum of 6 and maximum of 20 alphanumeric characters, Spaces are not allowed"}

                                                                />
                                                                <div className=" tooltip nopadding" style={{ position: "absolute !important", top: "33px", textAlign: "right", right: "45px", fontSize: "15px", }}>
                                                                    <i className="fa fa-question-circle" aria-hidden="true"></i>
                                                                    <span className="tooltiptext" style={{ fontSize: "12px", top: "-44px", left: "-100px", maxWidth: "180px" }} >Please set a User ID to access this site again</span>
                                                                </div>
                                                                <div className="col-sm-2" style={{ padding: "0px", position: "absolute", marginLeft: "190px", marginTop: "-35px" }}>
                                                                    {usernameVerified ? <div className="spin" /> : null}

                                                                    <div className="col-sm-12" id="valid1" style={{ display: "none" }}
                                                                    >
                                                                        <i className="fa fa-check" aria-hidden="true" style={{ color: "green", }}></i>
                                                                    </div>
                                                                    <div className="col-sm-12" id="invalid1" style={{ display: "none" }}>
                                                                        <i className="fa fa-times" aria-hidden="true" style={{ color: "red" }}></i>
                                                                    </div>

                                                                </div>

                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className="col-sm-4 nopadding">
                                                        <div className="row input-group" >

                                                            <div className="col-sm-9" style={{ paddingRight: "0px", postion: "relative" }}>

                                                                <TextField
                                                                    hintText="Typing"
                                                                    floatingLabelText="Password"
                                                                    name="password"
                                                                    autoComplete='none'
                                                                    type={this.state.togglePass}
                                                                    maxLength="15"
                                                                    className="input-width required simsfont"
                                                                    id="currentpasswo"
                                                                    onPaste={(e) => {
                                                                        e.persist();
                                                                        setTimeout(() => { this.onChangeFields(e) }, 4)
                                                                    }
                                                                    }
                                                                    onChange={this.onChangeFields.bind(this)}
                                                                    defaultValue={this.state.password || null}
                                                                    onBlur={this.handleVerifyFilled}
                                                                    underlineFocusStyle={styles.focusStyle}
                                                                    floatingLabelFocusStyle={styles.focusTextStyle}
                                                                    errorText={correctPassword ? null : "Not a valid password"}
                                                                />
                                                                <div className="hintQuestion">
                                                                    <span toggle="#currentpasswo" className={`${this.state.togglePassIcon} field-icon toggle-password`} style={{ marginTop: "35px", right: "-5px", cursor: "pointer" }} onClick={this.togglePassword} ></span>
                                                                    <div className=" tooltip nopadding" style={{ position: "absolute !important", top: "33px", textAlign: "right", right: "45px", fontSize: "15px", }}>
                                                                        <i className="fa fa-question-circle" aria-hidden="true"></i>
                                                                        <span className="tooltiptext" style={{ fontSize: "12px", top: "-87px", left: "-215px", maxWidth: "283px" }} >Your Password must contain at least 8 characters including one number, one lowercase letter, one uppercase letter and a special character. As an example, Rainbow123!</span>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="col-sm-1" style={{ padding: "0px 0px" }}>

                                                            </div>

                                                        </div>

                                                    </div>
                                                    <div className="col-sm-4 nopadding">
                                                        <div className="row input-group" >

                                                            <div className="col-sm-10" style={{ paddingRight: "0px", }}>
                                                                <TextField
                                                                    hintText="Typing"
                                                                    floatingLabelText="Confirm Password"
                                                                    id="confpassword"
                                                                    name="confirmPassword"
                                                                    type={this.state.toggleConfirmPass}
                                                                    autoComplete='none'
                                                                    onBlur={this.onChangeFields.bind(this)}
                                                                    defaultValue={this.state.confirmPassword || null}
                                                                    maxLength="15"
                                                                    className="input-width required simsfont"
                                                                    onPaste={(e) => {
                                                                        e.persist();
                                                                        setTimeout(() => {
                                                                            this.setState({
                                                                                confirmPassword: e.target.value,
                                                                                correctConfirmPassword: true,
                                                                            })
                                                                        }, 500)
                                                                    }
                                                                    }
                                                                    underlineFocusStyle={styles.focusStyle}
                                                                    floatingLabelFocusStyle={styles.focusTextStyle}
                                                                    errorText={correctConfirmPassword ? null : "Password and Confirm Password should be same"}
                                                                />

                                                                <span toggle="#confpassword" style={{ marginTop: "35px", position: "absolute", right: "-5px", cursor: "pointer" }} className={`${this.state.toggleConfirmPassIcon} field-icon toggle-password`} onClick={this.toggleConfirmPassword}  ></span>
                                                            </div>

                                                        </div>
                                                    </div>

                                                </div>
                                            </div>


                                            <div className="col-sm-12 ">
                                                <div className="row">
                                                    <div className="col-sm-4 nopadding">
                                                        <div className="row input-group" >

                                                            <div className="col-sm-10" style={{ paddingRight: "0px" }} >

                                                                <SelectField
                                                                    value={this.state.secretQuestionCode || null}
                                                                    onChange={this.handleSelect}
                                                                    className="input-width required simsfont"
                                                                    id="username"
                                                                    floatingLabelText="Secret Question"
                                                                >
                                                                    {(secretQues.message === "Success") ? secretQues.body.map((value, i) =>
                                                                        <MenuItem className="menuitem" value={secretQues.body[i].secretQuestionCode} primaryText={secretQues.body[i].description} key={i} />
                                                                    ) : <div></div>}
                                                                </SelectField>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className="col-sm-4 nopadding">
                                                        <div className="row input-group" >

                                                            <div className="col-sm-10" style={{ paddingRight: "0px" }} >
                                                                {(this.state.secretQuestionCode === "DOB") ?
                                                                    <div className="group">
                                                                        <InputMask mask="99/99/9999"
                                                                            name="secretAnswer"
                                                                            id="secretAnswer"
                                                                            ref="item"
                                                                            onChange={this.handleSecretDate}
                                                                            placeholder="DD/MM/YYYY"
                                                                            onBlur={this.handleVerifyFilled}
                                                                            value={this.state.secretAnswer}
                                                                        />
                                                                        <span className="highlight"></span>
                                                                        <span className="bar"></span>
                                                                        <label className='simsfont '>Secret Answer(Date Of Birth) <span style={{ color: "#e32", fontSize: "18px" }}> *</span></label>
                                                                    </div>
                                                                    :
                                                                    <TextField
                                                                        hintText="Typing"
                                                                        floatingLabelText="Secret Answer"
                                                                        name="secretAnswer"
                                                                        autoComplete='off'
                                                                        type="type"
                                                                        className="input-width required simsfont"
                                                                        id="username"
                                                                        maxLength="20"
                                                                        onPaste={(e) => {
                                                                            e.persist();
                                                                            setTimeout(() => {
                                                                                this.setState({
                                                                                    secretAnswer: e.target.value
                                                                                })
                                                                            }, 500)
                                                                        }
                                                                        }
                                                                        onChange={this.onChangeFields.bind(this)}
                                                                        onBlur={this.handleVerifyFilled}
                                                                        defaultValue={this.state.secretAnswer}
                                                                        underlineFocusStyle={styles.focusStyle}
                                                                        floatingLabelFocusStyle={styles.focusTextStyle}
                                                                        errorText={correctAnswer ? null : "Must contain minimum 3 characters/numericals"}
                                                                    />
                                                                }
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <div className='col-sm-4'>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ) :
                                    (
                                        <div className="col-sm-12 text-center" style={{ marginTop: 40, marginBottom: 40 }}>
                                            <p className="simsfont" style={{ color: "#d64a4a" }}>
                                                We couldn't load your card details. Please refresh the page and try again, or contact support if the problem continues.
                                            </p>
                                        </div>
                                    )
                                }
                            </div >
                        )
                    }
                    else if ((this.state.existingUser === "yes" || this.state.existingUser === "true")) {
                        const { loader5 } = this.state
                        return (

                            <div className="col-md-6 card-images nopaddingleft" style={{ margin: "auto" }} >
                                <div className="d-flex flex-row-reverse" style={{ marginTop: 40 }}>
                                    <div className="loginbox col-auto justify-content-end  p-4 mb-5" >


                                        <div className="col-12">
                                            <div className="logmainheading mt-3">Sign in to Your Card Account</div>
                                        </div>
                                        {loader5 ? <div>
                                            <Loader />
                                        </div> :
                                            <div>
                                                <div className='col-12 '>
                                                    <TextField
                                                        hintText="User ID"
                                                        floatingLabelText="User ID"
                                                        id="uName"
                                                        type="text"
                                                        name="userName"
                                                        maxLength="20"
                                                        autoComplete='off'
                                                        onKeyDown={this.onEnterPress}
                                                        onChange={this.handelvalidateusername}
                                                        className="my-className simsfont"
                                                        underlineFocusStyle={styles.focusStyle}
                                                        floatingLabelFocusStyle={styles.focusTextStyle}
                                                        autoFocus={true}
                                                        fullWidth
                                                    />
                                                </div>
                                                <div className='col-12 pb-2'>
                                                    <TextField
                                                        hintText="Type Your Password"
                                                        floatingLabelText="Password"
                                                        type={this.state.toggleType}
                                                        name="password"
                                                        id="loginpassword"
                                                        className='simsfont'
                                                        autoComplete='none'
                                                        maxLength="15"
                                                        onKeyDown={this.onEnterPress}
                                                        onChange={this.handelvalidatepassword}
                                                        underlineFocusStyle={styles.focusStyle}
                                                        floatingLabelFocusStyle={styles.focusTextStyle}
                                                        fullWidth
                                                    />
                                                    <span toggle="#loginpassword" className={`${this.state.toggleIcon} field-icon toggle-password`} style={{ position: 'absolute', top: "30px", right: "20px", cursor: "pointer" }} onClick={this.toggle} ></span>
                                                </div>
                                                <div className='col-12 mt-2'>
                                                    <RaisedButton
                                                        label="Login"
                                                        type="submit"
                                                        className="btn-std"
                                                        backgroundColor="#FFCE39"
                                                        labelColor="#115876"
                                                        onClick={this.handleLogin}
                                                        buttonStyle={{ borderRadius: 50 }}
                                                        style={{ borderRadius: 50 }}
                                                    />
                                                </div>
                                                <div className="col-12 mt-4">
                                                    <Link to='/forgotpassword' className=' simsfont hoverlinks mr-3'> Forgot Your Password</Link>
                                                    <Link to='/forgotuserid' className=' simsfont hoverlinks mr-3'> Forgot Your User ID</Link>
                                                    <Link to='/resetquestion' className='simsfont hoverlinks'> Reset Secret Q&A</Link>
                                                </div>
                                            </div>}
                                    </div>

                                </div>
                            </div>

                        )
                    }
                    else {
                        return (
                            <div className="col-sm-12 text-center" style={{ marginTop: 40, marginBottom: 40 }}>
                                <LoaderSmall />
                            </div>
                        )
                    }
                    break
                case 2:
                    const { description } = this.state
                    const { userName, mobileNumber, emailId, secretPassword, secretPasswordDate } = this.state
                    const { activationcardState } = this.props

                    return (
                        <div className="" style={{ marginTop: "20px" }}>
                            <div className="row">

                                <div className="col-md-8 col-sm-12">
                                    <div className="row">
                                        <div className="" style={{ borderColor: "#fff", fontSize: "13px", marginLeft: "16px", marginTop: "15px", marginBottom: "30px", width: "100%" }}>
                                            <table className="table table-borderless table-sm" style={{ tableLayout: "fixed" }}>
                                                <tbody style={{ overflowWrap: "break-word" }}>
                                                    <tr>
                                                        <td style={{ fontWeight: "bold", width: "25%" }} >Email:  </td>
                                                        <td colspan="3" style={{ width: "35%" }}> {this.state.emailId}</td>

                                                    </tr>
                                                    <tr><td style={{ fontWeight: "bold" }} >User Name:</td>
                                                        <td colspan="2"> {this.state.userName}</td>
                                                        <td colspan="2" style={{ fontWeight: "bold" }} >Mobile Number:</td>
                                                        <td colspan="3" > {this.state.mobileNumber}</td> </tr>
                                                    <tr><td style={{ fontWeight: "bold" }} >Secret Question:</td>
                                                        <td colspan="2"> {description}</td>
                                                        <td colspan="2" style={{ fontWeight: "bold" }} >Secret Answer:</td>
                                                        <td colspan="3" > {this.state.secretQuestionCode === "DOB" ? secretPasswordDate : secretPassword}</td>
                                                    </tr>

                                                </tbody>
                                            </table>
                                            <div className="col-sm-12">
                                                <hr />
                                            </div>
                                        </div>
                                    </div>


                                </div>

                                {/* <div className="col-md-4" style={{ paddingLeft: "20px" }}>
                                        {localStorage.getItem('isDigitalCard') === "true" ?
                                            <CardDesign
                                                name={localStorage.getItem('firstName') + " " + localStorage.getItem('lastName')}
                                                cardno={localStorage.getItem('cdNo')}
                                                balance={localStorage.getItem('expiry') ? localStorage.getItem('expiry').slice(0, 2) + '/' + localStorage.getItem('expiry').slice(2) : ''}
                                                cardImage={localStorage.getItem('cardProgram')}
                                                startwith="4813"
                                            />
                                            :
                                            <CardDesign
                                                name={this.props.firstName + " " + this.props.lastName}
                                                cardno={activationcardState.body.cardNumber}
                                                balance={activationcardState.body.expiryDate.slice(0, 2) + '/' + activationcardState.body.expiryDate.slice(2)}
                                                cardImage={activationcardState.body.cardProgram}
                                                startwith="4813"
                                            />
                                        }
                                    </div> */}
                                <div className="col-md-4" style={{ paddingLeft: "20px" }}>

                                    <CardDesign
                                        name={localStorage.getItem('firstName') + " " + localStorage.getItem('lastName')}
                                        // cardno={localStorage.getItem('cdNo')}
                                        cardno={localStorage.getItem('cardNumber') || localStorage.getItem('cdNo')}
                                        balance={localStorage.getItem('expiry') ? localStorage.getItem('expiry').slice(0, 2) + '/' + localStorage.getItem('expiry').slice(2) : ''}
                                        cardImage={localStorage.getItem('cardProgram')}
                                        startwith="4813"
                                        showView="N"
                                    />

                                </div>
                            </div>
                            <div className="col-sm-10 text-center margin-capcha">
                                <Recaptcha
                                    sitekey="6LeRorofAAAAACriDJ7aN2WI9LOCRz8aN2KzqU3C"
                                    render="explicit"
                                    verifyCallback={this.verifyCallback}
                                    expiredCallback={this.expiredCallback}
                                    onloadCallback={callback}
                                />
                            </div>
                        </div >
                    );
                case 3:
                    const { pinError: ppinError, confirmPinError: pconfirmPinError, PinMatchecdError: pPinMatchecdError } = this.state;
                    const pmsg = "PIN must be 4 numbers"
                    const pmsg2 = "PIN and confirm PIN do not match"
                    const perrorDiv = <div className="pl-0 simsfont col-sm-12 " style={{ marginTop: 10, color: "#d64a4a", fontSize: "13px" }}>
                        {pmsg}
                    </div>
                    const perrorDiv2 = <div className="pl-0 simsfont col-sm-12 " style={{ marginTop: 10, color: "#d64a4a", fontSize: "13px" }}>
                        {pmsg2}
                    </div>

                    return (
                        <div className="row">
                            <div className="col-md-12 p-0 m-0" style={{ marginTop: "20px" }}>
                                <h4 className='logmainheading mainheading'>
                                    Personal Identification Number
                                </h4>

                                <p>
                                    Please choose your personal identification number (PIN). You will need to enter this PIN when prompted by the merchant when using your card. You can change your PIN at any time by clicking on Change PIN from the Additional Services Menu. Enter a 4 digit number.
                                </p>
                            </div>
                            <div className="col-md-12">
                                <div className="row pt-3 pb-3">
                                    <div className="col-md-4">
                                        <div className="row input-group">
                                            <div className="col-sm-10">
                                                <label className='fsize12 btn-block'>PIN</label>
                                                <div className="group mb-2">
                                                    <InputMask mask="9999" className="iconParent pl-5" maskchar="*" type={this.state.toggleType1} value={this.state.pin} name="pin" onChange={(event, value) => { this.handleValueChange(event, value) }}
                                                        onBlur={(value) => { this.handleValue(value); }} />
                                                    <span className='cardicon'></span>
                                                </div>
                                                <span toggle="#pin" className={`${this.state.togglePINIcon} field-icon toggle-password`} style={{ float: "right", right: "30px", position: "absolute", top: "46px", cursor: "pointer" }} onClick={this.togglePIN}></span>
                                                {ppinError && perrorDiv}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-4">
                                        <div className="row input-group">
                                            <div className="col-sm-10">
                                                <label className='fsize12 btn-block'>Confirm PIN</label>
                                                <div className="group mb-2">
                                                    <InputMask mask="9999" className="iconParent pl-5" maskchar="*" type={this.state.toggleText} value={this.state.confirmPin} name="confirmPin" onChange={(e, value) => { this.handleValueChangeconfirm(e, value); }}
                                                        onBlur={(e, value) => { this.handleValueConfirm(e, value); }} />
                                                    <span className='cardicon'></span>
                                                </div>
                                                <span toggle="#cofirmpin" className={`${this.state.toggleConfirmPINIcon} field-icon toggle-password`} style={{ float: "right", right: "30px", position: "absolute", top: "46px", cursor: "pointer" }} onClick={this.toggleConfirmPIN}></span>
                                                {pconfirmPinError && perrorDiv}
                                                {pPinMatchecdError && perrorDiv2}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                    break

                default:
                    return (
                        <div >Something Went Wrong</div>
                    )
            }
        }
        else if ((this.state.existingUser === "yes" || this.state.existingUser === "true")) {
            switch (stepIndex) {
                case 1:
                    const { secretQues } = this.props
                    const { correctUsername, usernameVerified, correctPassword } = this.state
                    return (
                        <div className="row">
                            <div className="col-md-12" style={{ marginTop: "20px" }}>
                                <h4>Secure Login Detail</h4>

                            </div>

                            <div className="col-md-4 nopaddingright">
                                <div className="row input-group" >
                                    <div className="col-sm-2 activatesecondinput" >
                                        <i className="fa fa-user text-dark " aria-hidden="true"></i>
                                    </div>
                                    <div className="col-sm-9" style={{ paddingRight: "0px" }}>

                                        <TextField
                                            hintText="Typing"
                                            floatingLabelText="User ID"
                                            type="text"
                                            name="userName"
                                            id="username"
                                            autoComplete='none'
                                            maxLength="20"
                                            minLength="6"
                                            defaultValue={this.state.userName || null}
                                            className="input-width simsfont"
                                            onChange={this.onChangeFields.bind(this)}
                                            underlineFocusStyle={styles.focusStyle}
                                            floatingLabelFocusStyle={styles.focusTextStyle}
                                            errorText={correctUsername ? null : "Must contain minimum 6 characters"}
                                        />

                                    </div>
                                    <div className="col-sm-1" style={{ padding: "0px" }}>
                                        {usernameVerified ? <LoaderSmall /> : null}
                                        <div className="col-sm-12" id="valid1" style={{ display: "none", marginTop: "35px" }}>
                                            <i className="fa fa-check" aria-hidden="true" style={{ color: "green" }}></i>
                                        </div>
                                        <div className="col-sm-12" id="invalid1" style={{ display: "none", marginTop: "35px" }}>
                                            <i className="fa fa-times" aria-hidden="true" style={{ color: "red" }}></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4 nopaddingright">
                                <div className="row input-group" >

                                    <div className="col-sm-10" >
                                        <TextField
                                            hintText="Typing"
                                            floatingLabelText="Password"
                                            name="password"
                                            type={this.state.toggleType}
                                            id="oldpass"
                                            autoComplete='none'
                                            maxLength="15"
                                            className="input-width simsfont"
                                            underlineFocusStyle={styles.focusStyle}
                                            defaultValue={this.state.password || null}
                                            floatingLabelFocusStyle={styles.focusTextStyle}
                                            errorText={correctPassword ? null : "Please check help button"}
                                        />
                                        <span className={`${this.state.toggleIcon} signinput toggle-password`} toggle="#oldpass" style={{ marginTop: "40px", position: "absolute", right: "-5px" }} ></span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4 nopadding right">
                                <div className="row input-group" >

                                    <div className="col-sm-10" >
                                        <TextField
                                            hintText="Typing"
                                            floatingLabelText="Confirm Password"
                                            name="confirmPassword"
                                            type="password"
                                            autoComplete='none'
                                            maxLength="15"
                                            id="confirmPassword"
                                            className="input-width simsfont"
                                            defaultValue={this.state.confirmPassword || null}
                                            underlineFocusStyle={styles.focusStyle}
                                            onFocus={this.removematchpwd}
                                            floatingLabelFocusStyle={styles.focusTextStyle}
                                        />
                                        <span className="fa fa-fw fa-eye signinput toggle-password" toggle="#confirmPassword" style={{ marginTop: "40px", position: "absolute", right: "-5px" }} ></span>
                                    </div>
                                    <div className="col-sm-1 nopadding">
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4 nopaddingright">
                                <div className="row input-group" >
                                    <div className="col-sm-2 input-icon" >
                                        <i className="fa fa-question-circle text-dark " aria-hidden="true"></i>
                                    </div>
                                    <div className="col-sm-10">
                                        <SelectField
                                            value={this.state.secretQuestionCode}
                                            onChange={this.handleSelect}
                                            floatingLabelText="Secret Question"
                                            className="input-width simsfont"
                                        >
                                            {(secretQues.message === "Success") ? secretQues.body.map((value, i) =>
                                                <MenuItem className="menuitem" value={secretQues.body[i].secretQuestionCode} primaryText={secretQues.body[i].description} key={i} />
                                            ) : <div></div>}
                                        </SelectField>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4 nopaddingright">
                                <div className="row input-group" >
                                    <div className="col-sm-2 input-icon" >
                                        <i className="fa fa-exclamation-circle text-dark " aria-hidden="true"></i>
                                    </div>
                                    <div className="col-sm-10" >
                                        <TextField
                                            hintText="Typing"
                                            floatingLabelText="Secret Answer"
                                            name="secretPassword"
                                            type="type"
                                            autoComplete='none'
                                            className="input-width simsfont"
                                            maxLength="50"
                                            defaultValue={this.state.secretPassword || null}
                                            underlineFocusStyle={styles.focusStyle}
                                            floatingLabelFocusStyle={styles.focusTextStyle}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4 nopaddingright">
                                <div className="row input-group" >
                                    <div className="col-sm-2 input-icon" >
                                        <i className="fa fa-envelope text-dark " aria-hidden="true"></i>
                                    </div>
                                    <div className="col-sm-9" >
                                        <TextField
                                            hintText="Typing"
                                            floatingLabelText="Email"
                                            name="email"
                                            type="text"
                                            className="input-width simsfont"
                                            autoComplete='none'
                                            maxLength="50"
                                            defaultValue={this.state.email || null}
                                            underlineFocusStyle={styles.focusStyle}
                                            floatingLabelFocusStyle={styles.focusTextStyle}

                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="required" style={{ fontSize: "11px", marginTop: "20px", marginLeft: "18px" }}><b>Note:</b><label>All fields are mandatory</label></div>
                        </div >

                    );

                case 2:
                    const { userName } = this.state
                    const { activationcardState } = this.props

                    return (
                        <div className="tile box-shadow-style" style={{ marginTop: "20px" }}>
                            <div className="row">

                                <div className="col-md-9 col-sm-12">
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <div className="row">
                                                <div className="offset-md-1 col-md-3 tilepadding">
                                                    <label className="simsfont tilecontent">User ID </label>
                                                </div>
                                                <div className="col-md-6 text-left tilepadding">
                                                    <span className="simsfont tileheadername">   {userName} </span><br />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="row">
                                                <div className="offset-md-1 col-md-3 tilepadding">
                                                    <label className="simsfont tilecontent">User ID </label>
                                                </div>
                                                <div className="col-md-6 text-left tilepadding">
                                                    <span className=" simsfont tileheadername">   {userName} </span><br />
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                                <div className=" col-md-3">
                                    <CardDesign name={this.props.firstName + " " + this.props.lastName} cardno={activationcardState.cardNumber} balance={activationcardState.body.expiryDate.slice(0, 2) + '/' + activationcardState.body.expiryDate.slice(2)} cardImage={activationcardState.body.cardProgram} startwith="4813" showView="N"/>
                                </div>
                            </div>


                        </div>

                    );
                default:
                    return (
                        <div>Something Went Wrong</div>
                    )
            }

        }
    }


    handleActivate() {

        const { expiry, pin, confirmPin, } = this.state;

        if (pin.length !== 4) {
            this.setState({
                pinError: true,
            })
        } else {
            this.setState({
                pinError: false,
            })
        }
        if (confirmPin.length !== 4) {
            this.setState({ confirmPinError: true })
        } else {
            this.setState({ confirmPinError: false })
        }

        if (pin !== "" && confirmPin !== "" && expiry !== "") {
            if (pin.length === 4) {
                if (confirmPin.length === 4) {
                    if (pin === confirmPin && this.state.expiryVerified === true) {
                        (localStorage.getItem("existingUser") === "true" || localStorage.getItem("existingUser") === "yes") ?
                            this.handleOldUser()
                            :
                            this.handleNewUser()
                    }
                }
            }
        }
    }
    handleback = () => {

        // 
        // if (correctFirstname === false) {
        //     this.setState({
        //         correctFirstname: false,
        //     })
        // }
        // else if (correctLastname === false) {
        //     this.setState({
        //         correctLastname: false,
        //     })
        // }
        // else if (correctUsername === false) {
        //     this.setState({
        //         correctUsername: false,
        //     })
        // }
        // else if (correctAddress === false) {
        //     this.setState({
        //         correctAddress: false,
        //     })
        // }
        // else if (correctAddress1 === false) {
        //     this.setState({
        //         correctAddress1: false,
        //     })
        // } else if (correctAnswer === false) {
        //     this.setState({
        //         correctAnswer: false,
        //     })
        // } else if (correctEmail === false) {
        //     this.setState({
        //         correctEmail: false,
        //     })
        // } else if (correctCity === false) {
        //     this.setState({
        //         correctCity: false,
        //     })
        // } else if (correctState === false) {
        //     this.setState({
        //         correctState: false,
        //     })
        // } else if (correctPincode === false) {
        //     this.setState({
        //         correctPincode: false,
        //     })
        // } else if (correctConfirmPassword === false) {
        //     this.setState({
        //         correctConfirmPassword: false,
        //     })
        // } else if (correctPassword === false) {
        //     this.setState({
        //         correctPassword: false,
        //     })
        // } else if (correctMobileNumber === false) {
        //     this.setState({
        //         correctMobileNumber: false,
        //     })
        // }
        this.props.history.push(this.setState({
            stepIndex: 1,
            verifyBtndisabled: true,
        }))
        // 
    }
    handelepassword = (e, value) => {
        // eslint-disable-next-line
        var passwd = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@.+-,'#\$%\^&\*])(?=.{8,})");
        if (e.target.name === "password") {
            if (passwd.test(e.target.value)) {
                this.setState({
                    correctPassword: true,
                    password: value
                })
            } else {
                this.setState({
                    correctPassword: false
                })
            }
        }

    }
    handleBalanceCheck() {
        this.setState({
            loader1: true,
        })
        const { activationcardState } = this.props
        let kitNo = activationcardState.body && activationcardState.body.customerId
        let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ
        let gbid = getClientId();
        let traceId = getClientId();
        fetch(plink + services.get_balance + "/" + kitNo, {
            // method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'clientId': gbid,
                'clientSecret': getClientSecret(gbid, kitNo),
                'X-Trace-Id': traceId,
                'X-Client-APP': buildClientHeader(),

                // 'hmac-value':  encryption(state)
            }),
            // body: JSON.stringify(state)
        })
            .then(res => {
                if (res.status === 200 || res.status === 201) {
                    res.json().then(json => {

                        this.setState({

                            balance: json.balance,
                            loader1: false,
                        }, () => {

                        });
                    })
                }
                else if (res.status === 401) {
                    localStorage.clear();
                    this.props.history.push('/sessionout')
                }
                else {
                    toast.error(res.headers.get('message'), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    });
                }
            })
        // }
    }






    // Handle Verify Old Api Handle

    handleVerifyOld() {
        const { response } = this.state;
        const { publicKey, activationcardState } = this.props;

        let _this = this;

        const public_Key = publicKey.body.publickey;

        let encrypt = new JSEncrypt();
        encrypt.setPublicKey(public_Key);

        const data =
            activationcardState &&
                activationcardState.body
                ? activationcardState.body
                : {};


        const isDigitalCard =
            localStorage.getItem('isDigitalCard') === 'true';

        const resolvedIdExpiry = isDigitalCard ? localStorage.getItem('idExpiry') : (data && data.idExpiry);
        const resolvedExpiryDate = isDigitalCard ? localStorage.getItem('expiry') : (data && data.expiryDate);

        const pform = localStorage.getItem('pform');

        /*
         * ============================================================
         * AU ACTIVATION
         * ============================================================
         */



        if (pform === 'AU') {

            const auExpiryDate = isDigitalCard ? localStorage.getItem('expiry') : (data && data.expiryDate);
            const auDateOfBirth = isDigitalCard ? localStorage.getItem('dateofbirth') : this.state.dateofbirth;
            const auSpecialDate = isDigitalCard ? localStorage.getItem('dob') : (data && data.specialDate);
            const auKitNo = isDigitalCard ? localStorage.getItem('KitNumber') : (data && data.kitNo);
            const auCardType = isDigitalCard ? localStorage.getItem('cardType') : (data && data.cardType);
            const auCardProgram = isDigitalCard ? localStorage.getItem('cardProgram') : (data && data.cardProgram);
            const auAccountId = isDigitalCard ? localStorage.getItem('accountId') : (data && data.accountId);
            const auIdExpiry = isDigitalCard ? localStorage.getItem('idExpiry') : (data && data.idExpiry);
            const auIdNumber = isDigitalCard ? localStorage.getItem('idNumber') : this.state.idNumber;
            const auIdType = isDigitalCard ? localStorage.getItem('idType') : (data && data.idType);
            const auGender = isDigitalCard ? localStorage.getItem('gender') : (data && data.gender);
            const auTitle = isDigitalCard ? localStorage.getItem('title') : (data && data.title);
            const auCardProcessor = isDigitalCard ? localStorage.getItem('cardProcessor') : (data && data.cardProcessor);
            const auAtmAccess = isDigitalCard ? localStorage.getItem('atmAccess') === 'true' : (data && data.atmAccess);
            const auTapAndPay = isDigitalCard ? localStorage.getItem('tapAndPay') === 'true' : (data && data.tapAndPay);
            const auCustomerId = isDigitalCard ? localStorage.getItem('customerId') : (data && data.customerId);
            const auCardholderId = isDigitalCard ? localStorage.getItem('cardholderId') : (data && data.cardholderId);
            const auProgramId = isDigitalCard ? localStorage.getItem('programId') : (data && data.programId);
            const auKycStatus = isDigitalCard ? localStorage.getItem('kycStatus') : (data && data.kycStatus);
            const auFirstName = isDigitalCard ? localStorage.getItem('firstName') : this.state.firstName;
            const auLastName = isDigitalCard ? localStorage.getItem('lastName') : this.state.lastName;
            const auMiddleName = isDigitalCard ? localStorage.getItem('middleName') : this.state.middleName;
            const auMobileNumber = isDigitalCard ? localStorage.getItem('mobileNumber') : this.state.mobileNumber;
            const auEmailId = isDigitalCard ? localStorage.getItem('emailId') : this.state.emailId;
            const auCity = isDigitalCard ? localStorage.getItem('city') : this.state.city;
            const auState = isDigitalCard ? localStorage.getItem('state') : this.state.state;
            const auCountry = isDigitalCard ? localStorage.getItem('countryName') : this.state.countryName;
            const auCountryCode = isDigitalCard ? localStorage.getItem('countryCode') : this.state.countryCode;
            const auAddress = isDigitalCard ? localStorage.getItem('address') : this.state.address;
            const auAddress2 = isDigitalCard ? localStorage.getItem('address2') : this.state.address2;
            const auPincode = isDigitalCard ? localStorage.getItem('pincode') : this.state.pincode;
            const auStreetNumber = isDigitalCard ? (localStorage.getItem('streetNumber') || "") : (this.state.streetNumber || "");

            if (!auExpiryDate) {
                this.setState({ verifyBtndisabled: false, loader: false });
                toast.error('Expiry Date is required', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true
                });
                return;
            }

            let state = {
                applicationId: 'klickexau',
                cardNumber: encrypt.encrypt(localStorage.getItem('cdNo')),
                otpValidation: localStorage.getItem('otpValidation') === "true",
                cardType: auCardType,
                mobileNumber: auMobileNumber,
                cardPin: encrypt.encrypt(this.state.pin),
                city: auCity,
                dateofbirth: auDateOfBirth,
                emailId: encrypt.encrypt(auEmailId),
                expiryDate: encrypt.encrypt(auExpiryDate),
                firstName: auFirstName,
                lastName: auLastName,
                middleName: auMiddleName,
                password: encrypt.encrypt(this.state.password),
                confirmPassword: encrypt.encrypt(this.state.confirmPassword),
                pincode: auPincode,
                secretPassword: encrypt.encrypt(this.state.secretPassword),
                secretQuestionCode: encrypt.encrypt(this.state.secretQuestionCode),
                state: auState,
                userName: encrypt.encrypt(this.state.userName),
                migratedUser: false,
                migratedUserPasswordUpdated: false,
                idExpiry: auIdExpiry,
                specialDate: auSpecialDate,
                kitNo: auKitNo,
                kycStatus: auKycStatus,
                countryCode: auCountryCode,
                country: auCountry,
                countryOfIssue: this.state.countryName1,
                idNumber: auIdNumber,
                idType: auIdType,
                address2: auAddress2,
                address: auAddress,
                gender: auGender,
                title: auTitle,
                cardProcessor: auCardProcessor,
                cardProgramId: auCardProgram,
                atmAccess: auAtmAccess,
                tapAndPay: auTapAndPay,
                customerId: auCustomerId,
                accountId: auAccountId,
                cardholderId: auCardholderId,
                programId: auProgramId,
                streetNumber: auStreetNumber
            };

            this.setState({ verifyBtndisabled: true, loader: true });

            console.log("Sending AU activation data", state);

            const plink = process.env.REACT_APP_SERVICEURL_AU;
            const giid = getClientId();
            const traceId = getClientId();

            fetch(
                plink + services.update_user_info + "/?g-recaptcha-response=" + response,
                {
                    method: 'POST',
                    headers: new Headers({
                        'Content-Type': 'application/json',
                        clientId: giid,
                        clientSecret: getClientSecret(giid, auEmailId),
                        'X-Trace-Id': traceId,
                        'X-Client-APP': buildClientHeader()
                    }),
                    body: JSON.stringify(state)
                }
            )
                .then(response => {
                    if (response.status === 200 || response.status === 201) {
                        toast.success(response.headers.get('message'), {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false
                        });

                        this.setState({ loader: false });

                        response.json().then(function (object) {
                            const exp = object.expiryInMinutes;

                            if (exp) {
                                const expiry = exp * 60000 + new Date().getTime();
                                localStorage.setItem('expiryTime', JSON.stringify(expiry));
                            }

                            localStorage.setItem("loginState", true);
                            localStorage.setItem('memberId', object.memberId);
                            localStorage.setItem('token', object.token);
                            localStorage.setItem('accountId', object.accountId);
                            localStorage.setItem('kycStatus', object.kycStatus);
                            localStorage.setItem("kycMessage", object.kycStatusMessage);
                            localStorage.setItem("emailID", object.emailId);
                            localStorage.setItem("otpValidation", object.otpValidation);
                            localStorage.setItem('lastSuccessfulLogin', object.lastSuccessfulLogin);
                            localStorage.setItem('lastUnsuccessfulLogin', object.lastUnsuccessfulLogin);
                            localStorage.setItem('cardTypes', object.cardTypes);
                            localStorage.setItem('shlimit', object.cardholderKYCLevel);
                            localStorage.setItem('kycintegration', object.kycIntegration);
                            localStorage.setItem('showIncrease', true);

                            setTimeout(function () {
                                _this.props.history.push("/home");
                            }, 3000);
                        });
                    }
                    else if (response.status === 409 || response.status === 400) {
                        response.json().then(json => {
                            const message = json.message || response.headers.get('message');
                            toast.error(message, {
                                position: "top-right",
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true
                            });
                        });
                        this.setState({ loader: false, verifyBtndisabled: false });
                    }
                    else {
                        this.setState({ loader: false, verifyBtndisabled: false });
                        toast.error(response.headers.get('message'), {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            draggable: true
                        });
                    }
                })
                .catch(error => {
                    console.error("AU activation error:", error);
                    this.setState({ loader: false, verifyBtndisabled: false });
                    toast.error("Unable to activate card. Please try again.", {
                        position: "top-right",
                        autoClose: 5000
                    });
                });

            return;
        }


        /*
         * ============================================================
         * NZ ACTIVATION
         * ============================================================

         */

        // const isDigitalCard =
        //     localStorage.getItem('isDigitalCard') === 'true';


        if (isDigitalCard) {

            const nzExpiryDate =
                localStorage.getItem('expiry');

            const nzDateOfBirth =
                localStorage.getItem('dateofbirth');

            const nzSpecialDate =
                localStorage.getItem('dob');

            const nzKitNo =
                localStorage.getItem('KitNumber');

            const nzCardType =
                localStorage.getItem('cardType');

            const nzCardProgram =
                localStorage.getItem('cardProgram');

            const nzAccountId =
                localStorage.getItem('accountId');

            const nzIdExpiry =
                localStorage.getItem('idExpiry');

            const nzIdNumber =
                localStorage.getItem('idNumber');

            const nzIdType =
                localStorage.getItem('idType');

            const nzGender =
                localStorage.getItem('gender');

            const nzTitle =
                localStorage.getItem('title');

            const nzCardProcessor =
                localStorage.getItem('cardProcessor');

            const nzAtmAccess =
                localStorage.getItem('atmAccess') === 'true';

            const nzTapAndPay =
                localStorage.getItem('tapAndPay') === 'true';

            const nzCustomerId =
                localStorage.getItem('customerId');

            const nzCardholderId =
                localStorage.getItem('cardholderId');

            const nzProgramId =
                localStorage.getItem('programId');

            const nzKycStatus =
                localStorage.getItem('kycStatus');

            const nzFirstName =
                localStorage.getItem('firstName');

            const nzLastName =
                localStorage.getItem('lastName');

            const nzMiddleName =
                localStorage.getItem('middleName');

            const nzMobileNumber =
                localStorage.getItem('mobileNumber');

            const nzEmailId =
                localStorage.getItem('emailId');

            const nzCity =
                localStorage.getItem('city');

            const nzState =
                localStorage.getItem('state');

            const nzCountry =
                localStorage.getItem('countryName');

            const nzCountryCode =
                localStorage.getItem('countryCode');

            const nzAddress =
                localStorage.getItem('address');

            const nzAddress2 =
                localStorage.getItem('address2');

            const nzPincode =
                localStorage.getItem('pincode');

            const nzStreetNumber =
                localStorage.getItem('streetNumber') || "";


            const nzStatePayload = {

                applicationId: 'klickex',

                cardNumber:
                    encrypt.encrypt(
                        localStorage.getItem('cdNo')
                    ),

                otpValidation:
                    localStorage.getItem(
                        'otpValidation'
                    ) === "true",

                cardType:
                    nzCardType,

                mobileNumber:
                    nzMobileNumber,

                cardPin:
                    encrypt.encrypt(
                        this.state.pin
                    ),

                city:
                    nzCity,

                dateofbirth:
                    nzDateOfBirth,

                emailId:
                    encrypt.encrypt(
                        nzEmailId
                    ),

                expiryDate:
                    encrypt.encrypt(
                        nzExpiryDate
                    ),

                firstName:
                    nzFirstName,

                lastName:
                    nzLastName,

                middleName:
                    nzMiddleName,

                password:
                    encrypt.encrypt(
                        this.state.password
                    ),

                confirmPassword:
                    encrypt.encrypt(
                        this.state.confirmPassword
                    ),

                pincode:
                    nzPincode,

                secretPassword:
                    encrypt.encrypt(
                        this.state.secretPassword
                    ),

                secretQuestionCode:
                    encrypt.encrypt(
                        this.state.secretQuestionCode
                    ),

                state:
                    nzState,

                userName:
                    encrypt.encrypt(
                        this.state.userName
                    ),

                migratedUser: false,

                migratedUserPasswordUpdated: false,

                idExpiry:
                    nzIdExpiry,

                specialDate:
                    nzSpecialDate,

                kitNo:
                    nzKitNo,

                kycStatus:
                    nzKycStatus,

                countryCode:
                    nzCountryCode,

                country:
                    nzCountry,


                countryOfIssue:
                    this.state.countryName1,

                idNumber:
                    nzIdNumber,

                idType:
                    nzIdType,

                address2:
                    nzAddress2,

                address:
                    nzAddress,

                gender:
                    nzGender,

                title:
                    nzTitle,

                cardProcessor:
                    nzCardProcessor,

                cardProgramId:
                    nzCardProgram,

                atmAccess:
                    nzAtmAccess,

                tapAndPay:
                    nzTapAndPay,

                customerId:
                    nzCustomerId,

                accountId:
                    nzAccountId,

                cardholderId:
                    nzCardholderId,

                programId:
                    nzProgramId,

                streetNumber:
                    nzStreetNumber
            };



            this.setState({
                verifyBtndisabled: true,
                loader: true
            });

            console.log(
                "Sending NZ digital activation data",
                nzStatePayload
            );
            const mobileNumber =
                localStorage.getItem('mobileNumber');

            const plink =
                process.env.REACT_APP_SERVICEURL_NZ;

            const giid =
                getClientId();

            const traceId =
                getClientId();


            fetch(
                plink +
                services.update_user_info +
                "/?g-recaptcha-response=" +
                response,
                {
                    method: 'POST',

                    headers: new Headers({

                        'Content-Type':
                            'application/json',

                        clientId:
                            giid,

                        clientSecret:
                            getClientSecret(
                                giid,
                                // mobileNumber
                                this.state.mobileNumber

                            ),

                        'X-Trace-Id':
                            traceId,

                        'X-Client-APP':
                            buildClientHeader()
                    }),

                    body:
                        JSON.stringify(
                            nzStatePayload
                        )
                }
            )
                .then(response => {

                    if (
                        response.status === 200 ||
                        response.status === 201
                    ) {

                        toast.success(
                            response.headers.get(
                                'message'
                            ),
                            {
                                position: "top-right",
                                draggablePercent: 60,
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: false
                            }
                        );

                        this.setState({
                            loader: false
                        });

                        response.json()
                            .then(function (object) {

                                const exp =
                                    object.expiryInMinutes;

                                if (exp) {

                                    const expiry =
                                        exp *
                                        60000 +
                                        new Date().getTime();

                                    localStorage.setItem(
                                        'expiryTime',
                                        JSON.stringify(
                                            expiry
                                        )
                                    );
                                }

                                localStorage.setItem(
                                    "loginState",
                                    true
                                );

                                localStorage.setItem(
                                    'memberId',
                                    object.memberId
                                );

                                localStorage.setItem(
                                    'token',
                                    object.token
                                );

                                localStorage.setItem(
                                    'accountId',
                                    object.accountId
                                );

                                localStorage.setItem(
                                    'kycStatus',
                                    object.kycStatus
                                );

                                localStorage.setItem(
                                    "kycMessage",
                                    object.kycStatusMessage
                                );

                                localStorage.setItem(
                                    "emailID",
                                    object.emailId
                                );

                                localStorage.setItem(
                                    "otpValidation",
                                    object.otpValidation
                                );

                                localStorage.setItem(
                                    'lastSuccessfulLogin',
                                    object.lastSuccessfulLogin
                                );

                                localStorage.setItem(
                                    'lastUnsuccessfulLogin',
                                    object.lastUnsuccessfulLogin
                                );

                                localStorage.setItem(
                                    'cardTypes',
                                    object.cardTypes
                                );

                                localStorage.setItem(
                                    'shlimit',
                                    object.cardholderKYCLevel
                                );

                                localStorage.setItem(
                                    'kycintegration',
                                    object.kycIntegration
                                );

                                localStorage.setItem(
                                    'showIncrease',
                                    true
                                );

                                setTimeout(function () {

                                    _this.props.history.push(
                                        "/home"
                                    );

                                }, 3000);

                            });
                    }

                    else if (
                        response.status === 409
                    ) {

                        response.json()
                            .then(json => {

                                const message =
                                    json.message ||
                                    response.headers.get(
                                        'message'
                                    );

                                toast.error(
                                    message,
                                    {
                                        position: "top-right",
                                        autoClose: 3000,
                                        hideProgressBar: false,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: true
                                    }
                                );
                            });

                        this.setState({
                            loader: false,
                            verifyBtndisabled: false
                        });
                    }

                    // else if (
                    //     response.status === 400
                    // ) {

                    //     response.json()
                    //         .then(json => {

                    //             const message =
                    //                 json.message ||
                    //                 response.headers.get(
                    //                     'message'
                    //                 );

                    //             toast.error(
                    //                 message,
                    //                 {
                    //                     position: "top-right",
                    //                     autoClose: 3000,
                    //                     hideProgressBar: false,
                    //                     closeOnClick: true,
                    //                     pauseOnHover: true,
                    //                     draggable: true
                    //                 }
                    //             );
                    //         });

                    //     this.setState({
                    //         loader: false,
                    //         verifyBtndisabled: false
                    //     });
                    // }

                    else if (
                        response.status === 400
                    ) {

                        response.json()
                            .then(json => {

                                const message =
                                    json.message ||
                                    response.headers.get(
                                        'message'
                                    );

                                toast.error(
                                    message,
                                    {
                                        position: "top-right",
                                        autoClose: 3000,
                                        hideProgressBar: false,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: true
                                    }
                                );
                            })
                            .catch(() => {
                                const message =
                                    response.headers.get('message') || 'Something went wrong. Please try again.';

                                toast.error(
                                    message,
                                    {
                                        position: "top-right",
                                        autoClose: 3000,
                                        hideProgressBar: false,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: true
                                    }
                                );
                            });

                        this.setState({
                            loader: false,
                            verifyBtndisabled: false
                        });
                    }

                    else {

                        this.setState({
                            loader: false,
                            verifyBtndisabled: false
                        });

                        toast.error(
                            response.headers.get(
                                'message'
                            ),
                            {
                                position: "top-right",
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                draggable: true
                            }
                        );
                    }
                })
                .catch(error => {

                    console.error(
                        "NZ activation error:",
                        error
                    );

                    this.setState({
                        loader: false,
                        verifyBtndisabled: false
                    });

                    toast.error(
                        "Unable to activate card. Please try again.",
                        {
                            position: "top-right",
                            autoClose: 5000
                        }
                    );
                });

            return;
        }


        /*
         * ============================================================
         * NZ PHYSICAL CARD / FALLBACK
         * ============================================================
         *
         */

        let state = {

            applicationId: 'klickex',

            cardNumber:
                encrypt.encrypt(
                    localStorage.getItem('cdNo')
                ),

            otpValidation:
                localStorage.getItem('otpValidation') === "true"
                    ? true
                    : false,

            cardType:
                data && data.cardType,

            mobileNumber:
                this.state.mobileNumber,

            cardPin:
                encrypt.encrypt(
                    this.state.pin
                ),

            city:
                this.state.city,

            dateofbirth:
                this.state.dateofbirth,

            emailId:
                encrypt.encrypt(
                    this.state.emailId
                ),

            expiryDate:
                encrypt.encrypt(
                    data && data.expiryDate
                ),

            firstName:
                this.state.firstName,

            lastName:
                this.state.lastName,

            password:
                encrypt.encrypt(
                    this.state.password
                ),

            confirmPassword:
                encrypt.encrypt(
                    this.state.confirmPassword
                ),

            pincode:
                this.state.pincode,

            secretPassword:
                encrypt.encrypt(
                    this.state.secretPassword
                ),

            secretQuestionCode:
                encrypt.encrypt(
                    this.state.secretQuestionCode
                ),

            state:
                this.state.state,

            userName:
                encrypt.encrypt(
                    this.state.userName
                ),

            migratedUser: false,

            migratedUserPasswordUpdated: false,

            idExpiry:
                data && data.idExpiry,

            specialDate:
                data && data.specialDate,

            kitNo:
                data && data.kitNo,

            kycStatus:
                data && data.kycStatus,

            countryCode:
                this.state.countryCode,

            country:
                this.state.countryName,

            countryOfIssue:
                this.state.countryName1,

            idNumber:
                this.state.idNumber,

            idType:
                data && data.idType,

            address2:
                this.state.address2,

            address:
                this.state.address,

            gender:
                data && data.gender,

            title:
                data && data.title,

            cardProcessor:
                data && data.cardProcessor,

            cardProgramId:
                data && data.cardProgram,

            atmAccess:
                data && data.atmAccess,

            tapAndPay:
                data && data.tapAndPay,

            customerId:
                data && data.customerId,

            accountId:
                data && data.accountId,

            cardholderId:
                data && data.cardholderId,

            programId:
                data && data.programId
        };


        this.setState({
            verifyBtndisabled: true,
            loader: true
        });

        console.log(
            "Sending NZ physical activation data",
            state
        );


        const plink =
            process.env.REACT_APP_SERVICEURL_NZ;

        const giid =
            getClientId();

        const traceId =
            getClientId();
        const mobileNumber =
            localStorage.getItem('mobileNumber');

        fetch(
            plink +
            services.update_user_info +
            "/?g-recaptcha-response=" +
            response,
            {
                method: 'POST',

                headers: new Headers({

                    'Content-Type':
                        'application/json',

                    clientId:
                        giid,

                    clientSecret:
                        getClientSecret(
                            giid,
                            this.state.mobileNumber
                        ),

                    'X-Trace-Id':
                        traceId,

                    'X-Client-APP':
                        buildClientHeader()
                }),

                body:
                    JSON.stringify(state)
            }
        )
            .then(response => {

                if (
                    response.status === 200 ||
                    response.status === 201
                ) {

                    toast.success(
                        response.headers.get(
                            'message'
                        ),
                        {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false
                        }
                    );

                    this.setState({
                        loader: false
                    });

                    response.json()
                        .then(function (object) {

                            const exp =
                                object.expiryInMinutes;

                            if (exp) {

                                const expiry =
                                    exp *
                                    60000 +
                                    new Date().getTime();

                                localStorage.setItem(
                                    'expiryTime',
                                    JSON.stringify(
                                        expiry
                                    )
                                );
                            }

                            localStorage.setItem(
                                "loginState",
                                true
                            );

                            localStorage.setItem(
                                'memberId',
                                object.memberId
                            );

                            localStorage.setItem(
                                'token',
                                object.token
                            );

                            localStorage.setItem(
                                'accountId',
                                object.accountId
                            );

                            localStorage.setItem(
                                'kycStatus',
                                object.kycStatus
                            );

                            localStorage.setItem(
                                "kycMessage",
                                object.kycStatusMessage
                            );

                            localStorage.setItem(
                                "emailID",
                                object.emailId
                            );

                            localStorage.setItem(
                                "otpValidation",
                                object.otpValidation
                            );

                            localStorage.setItem(
                                'lastSuccessfulLogin',
                                object.lastSuccessfulLogin
                            );

                            localStorage.setItem(
                                'lastUnsuccessfulLogin',
                                object.lastUnsuccessfulLogin
                            );

                            localStorage.setItem(
                                'cardTypes',
                                object.cardTypes
                            );

                            localStorage.setItem(
                                'shlimit',
                                object.cardholderKYCLevel
                            );

                            localStorage.setItem(
                                'kycintegration',
                                object.kycIntegration
                            );

                            localStorage.setItem(
                                'showIncrease',
                                true
                            );

                            setTimeout(function () {

                                _this.props.history.push(
                                    "/home"
                                );

                            }, 3000);

                        });
                }

                else {

                    this.setState({
                        loader: false,
                        verifyBtndisabled: false
                    });

                    toast.error(
                        response.headers.get(
                            'message'
                        ),
                        {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            draggable: true
                        }
                    );
                }
            })
            .catch(error => {

                console.error(
                    "NZ physical activation error:",
                    error
                );

                this.setState({
                    loader: false,
                    verifyBtndisabled: false
                });

                toast.error(
                    "Unable to activate card. Please try again.",
                    {
                        position: "top-right",
                        autoClose: 5000
                    }
                );
            });
    }






    handleVerify() {
        const { response } = this.state;
        const { publicKey, activationcardState } = this.props;

        let _this = this;

        const public_Key = publicKey.body.publickey;

        let encrypt = new JSEncrypt();
        encrypt.setPublicKey(public_Key);


        const data =
            activationcardState &&
                activationcardState.body
                ? activationcardState.body
                : {};
        const pform = localStorage.getItem('pform');

        /*
        * ============================================================
        * AU ACTIVATION 
        * ============================================================
        */

        if (pform === 'AU') {
            localStorage.setItem("emailId", this.state.emailId);
            localStorage.setItem("mobileNumber", this.state.mobileNumber)
            let state = {
                applicationId: 'klickexau',
                cardNumber: localStorage.getItem('eCard'),
                mobileNumber: this.state.mobileNumber,
                password: encrypt.encrypt(this.state.password),
                emailId: encrypt.encrypt(this.state.emailId),
                cardType: localStorage.getItem('cardType'),
                secretPassword: encrypt.encrypt(this.state.secretPassword),
                secretQuestionCode: encrypt.encrypt(this.state.secretQuestionCode),
                userName: encrypt.encrypt(this.state.userName),
            };

            this.setState({ verifyBtndisabled: true, loader: true });

            console.log("Sending AU activation data", state);

            const plink = process.env.REACT_APP_SERVICEURL_AU;
            const giid = getClientId();
            const traceId = getClientId();

            fetch(
                plink + services.update_user_info + "/?g-recaptcha-response=" + response,
                {
                    method: 'POST',
                    headers: new Headers({
                        'Content-Type': 'application/json',
                        clientId: giid,
                        clientSecret: getClientSecret(giid, this.state.mobileNumber),
                        'X-Trace-Id': traceId,
                        'X-Client-APP': buildClientHeader()
                    }),
                    body: JSON.stringify(state)
                }
            )
                .then(response => {
                    if (response.status === 200 || response.status === 201) {
                        toast.success(response.headers.get('message'), {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false
                        });

                        this.setState({ loader: false });

                        response.json().then(function (object) {
                            console.log("AU registration response", object);
                            const exp = object.expiryInMinutes;

                            if (exp) {
                                const expiry = exp * 60000 + new Date().getTime();
                                localStorage.setItem('expiryTime', JSON.stringify(expiry));
                            }

                            localStorage.setItem("loginState", true);
                            localStorage.setItem('memberId', object.memberId);
                            localStorage.setItem('token', object.token);
                            localStorage.setItem('accountId', object.accountId);
                            localStorage.setItem('kycStatus', object.kycStatus);
                            localStorage.setItem("kycMessage", object.kycStatusMessage);
                            localStorage.setItem("emailID", object.emailId);
                            localStorage.setItem("otpValidation", object.otpValidation);
                            localStorage.setItem('lastSuccessfulLogin', object.lastSuccessfulLogin);
                            localStorage.setItem('lastUnsuccessfulLogin', object.lastUnsuccessfulLogin);
                            localStorage.setItem('cardTypes', object.cardTypes);
                            localStorage.setItem('shlimit', object.cardholderKYCLevel);
                            localStorage.setItem('kycintegration', object.kycIntegration);
                            localStorage.setItem('showIncrease', true);
                            localStorage.setItem('memberId', object.memberId);
                            localStorage.setItem('accountId', object.accountId);
                            localStorage.removeItem('emailId')

                            localStorage.setItem('cardHolderAccountId', object.cardHolderAccountId);
                            localStorage.setItem('userAccountId', object.userAccountId);
                            // localStorage.setItem('kycStatus', object.kycStatus);

                            // localStorage.setItem('kitNumber', object.kitNumber);
                            localStorage.setItem('knectCustomerId', object.knectCustomerId);
                            _this.completeRegistrationWithPin(object);

                        });
                    }
                    else if (response.status === 409 || response.status === 400) {
                        response.json().then(json => {
                            const message = json.message || response.headers.get('message');
                            toast.error(message, {
                                position: "top-right",
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true
                            });
                        }).catch(() => {
                            const message = response.headers.get('message') || 'Something went wrong. Please try again.';
                            toast.error(message, {
                                position: "top-right",
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true
                            });
                        });
                        this.setState({ loader: false, verifyBtndisabled: false });
                    }
                    else {
                        this.setState({ loader: false, verifyBtndisabled: false });
                        toast.error(response.headers.get('message'), {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            draggable: true
                        });
                    }
                })
                .catch(error => {
                    console.error("AU activation error:", error);
                    this.setState({ loader: false, verifyBtndisabled: false });
                    toast.error("Unable to activate card. Please try again.", {
                        position: "top-right",
                        autoClose: 5000
                    });
                });

            return;
        }

        /*
        * ============================================================
        * NZ ACTIVATION 
    
        * ============================================================
        */
        else {
            localStorage.setItem("emailId", this.state.emailId);
            localStorage.setItem("mobileNumber", this.state.mobileNumber)
            let state = {
                applicationId: 'klickex',
                cardNumber: localStorage.getItem('eCard'),
                mobileNumber: this.state.mobileNumber,
                password: encrypt.encrypt(this.state.password),
                emailId: encrypt.encrypt(this.state.emailId),
                cardType: localStorage.getItem('cardType'),
                secretPassword: encrypt.encrypt(this.state.secretPassword),
                secretQuestionCode: encrypt.encrypt(this.state.secretQuestionCode),
                userName: encrypt.encrypt(this.state.userName),
            };

            this.setState({
                verifyBtndisabled: true,
                loader: true
            });

            console.log("Sending NZ activation data", state);

            const plink = process.env.REACT_APP_SERVICEURL_NZ;
            const giid = getClientId();
            const traceId = getClientId();

            fetch(
                plink + services.update_user_info + "/?g-recaptcha-response=" + response,
                {
                    method: 'POST',
                    headers: new Headers({
                        'Content-Type': 'application/json',
                        clientId: giid,
                        clientSecret: getClientSecret(giid, this.state.mobileNumber),
                        'X-Trace-Id': traceId,
                        'X-Client-APP': buildClientHeader()
                    }),
                    body: JSON.stringify(state)
                }
            )
                .then(response => {
                    if (response.status === 200 || response.status === 201) {
                        toast.success(response.headers.get('message'), {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false
                        });

                        this.setState({ loader: false });

                        response.json().then(function (object) {
                            console.log("NZ registration response", object);
                            const exp = object.expiryInMinutes;

                            if (exp) {
                                const expiry = exp * 60000 + new Date().getTime();
                                localStorage.setItem('expiryTime', JSON.stringify(expiry));
                            }

                            localStorage.setItem("loginState", true);
                            localStorage.setItem('memberId', object.memberId);
                            localStorage.setItem('token', object.token);
                            localStorage.setItem('accountId', object.accountId);
                            localStorage.setItem('kycStatus', object.kycStatus);
                            localStorage.setItem("kycMessage", object.kycStatusMessage);
                            localStorage.setItem("emailID", object.emailId);
                            localStorage.removeItem('emailId')
                            // localStorage.setItem("emailID",object.maskedEmailId)

                            localStorage.setItem("otpValidation", object.otpValidation);
                            localStorage.setItem('lastSuccessfulLogin', object.lastSuccessfulLogin);
                            localStorage.setItem('lastUnsuccessfulLogin', object.lastUnsuccessfulLogin);
                            localStorage.setItem('cardTypes', object.cardTypes);
                            localStorage.setItem('shlimit', object.cardholderKYCLevel);
                            localStorage.setItem('kycintegration', object.kycIntegration);
                            localStorage.setItem('showIncrease', true);
                            localStorage.setItem('cardHolderAccountId', object.cardHolderAccountId);
                            localStorage.setItem('userAccountId', object.userAccountId);
                            // localStorage.setItem('kycStatus', object.kycStatus);
                            // localStorage.setItem('kitNumber', object.kitNumber);
                            localStorage.setItem('knectCustomerId', object.knectCustomerId);
                            _this.completeRegistrationWithPin(object);


                        });
                    }

                    else if (response.status === 409 || response.status === 400) {
                        response.json().then(json => {
                            const message = json.message || response.headers.get('message');
                            toast.error(message, {
                                position: "top-right",
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true
                            });
                        }).catch(() => {
                            const message = response.headers.get('message') || 'Something went wrong. Please try again.';
                            toast.error(message, {
                                position: "top-right",
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true
                            });
                        });
                        this.setState({ loader: false, verifyBtndisabled: false });
                    }
                    else {
                        this.setState({ loader: false, verifyBtndisabled: false });
                        toast.error(response.headers.get('message'), {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            draggable: true
                        });
                    }
                })
                .catch(error => {
                    console.error("NZ activation error:", error);
                    this.setState({ loader: false, verifyBtndisabled: false });
                    toast.error("Unable to activate card. Please try again.", {
                        position: "top-right",
                        autoClose: 5000
                    });
                });
        }

    }


    completeRegistrationWithPin = (regObject) => {
        const { publicKey } = this.props;
        const _this = this;

        if (publicKey.status !== 200) {
            this.setState({ loader: false, verifyBtndisabled: false });
            return;
        }

        const public_Key = publicKey.body.publickey;
        let encrypt = new JSEncrypt();
        encrypt.setPublicKey(public_Key);


        let kitNumber = regObject.kitNumber || localStorage.getItem('kitNumber') || localStorage.getItem('KitNumber');
        kitNumber = kitNumber ? kitNumber.trim() : "";
        let newPinstate = {};
        if (kitNumber) {
            newPinstate = {
                cardPin: encrypt.encrypt(this.state.pin),
                applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',
                kitNumber: kitNumber,
            };
        } else {
            newPinstate = {
                cardPin: encrypt.encrypt(this.state.pin),
                applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',
                accountId: regObject.accountId || localStorage.getItem('accountId'),
            };
        }

        console.log("Sending setPin data after registration", newPinstate);

        let gid = getClientId();
        let traceId = getClientId();
        let plink =
            localStorage.getItem('pform') === 'AU'
                ? process.env.REACT_APP_SERVICEURL_AU
                : process.env.REACT_APP_SERVICEURL_NZ;

        fetch(plink + services.setPinpostRegKYC, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'clientId': gid,
                'clientSecret': getClientSecret(gid, this.state.pin),
                'X-Trace-Id': traceId,
                'X-Client-APP': buildClientHeader(),
            }),
            body: JSON.stringify(newPinstate)
        })
            .then(response => {
                if (response.status === 200 || response.status === 201 || response.status === 204) {
                    response.json().then(function (object) {
                        localStorage.setItem("accountId", object.accountId)
                        let exp = object.expiryInMinutes
                        let expiry = (exp * 60000 + new Date().getTime())
                        localStorage.setItem('expiryTime', JSON.stringify(expiry))
                        localStorage.setItem("loginState", true)
                        localStorage.setItem('memberId', object.memberId);
                        localStorage.setItem('token', object.token)
                        localStorage.setItem('kycStatus', object.kycStatus)
                        localStorage.setItem("kycMessage", object.kycStatusMessage)
                        localStorage.setItem('lastSuccessfulLogin', object.lastSuccessfulLogin);
                        localStorage.setItem('lastUnsuccessfulLogin', object.lastUnsuccessfulLogin);
                        localStorage.setItem('cardTypes', object.cardTypes);
                        localStorage.setItem('shlimit', object.cardholderKYCLevel);
                        localStorage.setItem('kycintegration', object.kycIntegration)
                        localStorage.setItem('showIncrease', true)
                        localStorage.setItem('emailID', object.emailId);

                        _this.setState({ loader: false });

                        // if (!object.token || !object.memberId) {
                        //     console.error("setPinpostRegKYC succeeded but no token/memberId in response.", object);
                        //     toast.error("Registration completed, but we couldn't start your session automatically. Please log in.", {
                        //         position: "top-right",
                        //         autoClose: 5000,
                        //     });
                        //     _this.setState({ verifyBtndisabled: false });
                        //     setTimeout(function () {
                        //         _this.props.history.push("/login");
                        //     }, 3000);
                        //     return;
                        // }

                        setTimeout(function () {
                            _this.props.history.push("/home")
                        }, 1500);
                    })
                } else {
                    _this.setState({ loader: false, verifyBtndisabled: false })
                    toast.error(response.headers.get('message') || 'Unable to set PIN', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true
                    });
                }
            })
            .catch(() => {
                _this.setState({ loader: false, verifyBtndisabled: false })
                toast.error('Unable to set PIN. Please try again.', {
                    position: "top-right",
                    autoClose: 5000,
                });
            });
    }


    parseErrors = data => {
        let errors = errorParser(data)
        this.setState({ parsedErrors: errors })
    }




    handleUserInfo() {
        if (this.state.userName !== "" && this.state.userName.length >= 6 && this.state.correctPassword === true && this.state.password === this.state.confirmPassword && this.state.validUserName === true && this.state.validUserId === true && this.state.password !== "" && this.state.emailId !== "" && this.state.mobileNumber !== "" && this.state.confirmPassword !== "" && this.state.secretPassword !== "") {
            this.setState({
                correctPassword: true,
                correctFirstname: true,
                correctLastname: true,
                correctUsername: true,
                correctAddress: true,
                correctAnswer: true,
                correctEmail: true,
                correctCity: true,
                correctState: true,
                validUserId: true,
                validUserName: true,
                correctMobileNumber: true,
                correctConfirmPassword: true,
                correctPincode: true,
                correctAnswerDate: true,
                correctDateofbirth: true,
                disabledBtn: false,
                // disabled: true,
                stepIndex: 2,
                // submitBtndisabled: true                  
            })
        }
        else {
            this.setState({
                correctPassword: this.state.correctPassword,
                validUserId: this.state.validUserId,
                // correctFirstname: this.state.firstName !== "",
                // correctLastname: this.state.lastName !== "",
                correctUsername: false,
                // correctAddress: this.state.address !== "",
                correctAnswer: this.state.secretAnswer !== "",
                correctEmail: this.state.emailId !== "",
                // correctCity: this.state.city !== "",
                // correctState: this.state.state !== "",
                correctMobileNumber: this.state.mobileNumber !== "",
                correctConfirmPassword: (this.state.password === this.state.confirmPassword),
                // correctPincode: this.state.pincode !== "",
                correctAnswerDate: this.state.dateSelect === true,
                // correctDateofbirth: this.state.dateSelected === true,
                stepIndex: 1,
            })
        }
    }



    // if(this.state.usernameVerified === true) {

    //     this.setState({ stepIndex: 2, })

    // } else {
    //     toast.error('Username already exist!'), {
    //         position: "top-right",
    //         draggablePercent: 60,
    //         autoClose: 3000,
    //         hideProgressBar: false,
    //         closeOnClick: true,
    //         pauseOnHover: true,
    //         draggable: false
    //     }

    // }

    // if (password !== "" && confirmPassword !== "" && email !== "" && userName !== "" && secretPassword !== "" && value !== "") {
    //     if (correctPassword === false) {
    //         this.setState({
    //             correctPassword: false,
    //         })

    //     }
    //     else {
    //         if (password === confirmPassword) {
    //             if (/^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})+\S*$/.test(email)) {
    //                 this.setState({  })
    //             }
    //         } else {
    //             toast.error('New Password and Confirm Password should be same'), {
    //                 position: "top-right",
    //                 draggablePercent: 60,
    //                 autoClose: 3000,
    //                 hideProgressBar: false,
    //                 closeOnClick: true,
    //                 pauseOnHover: true,
    //                 draggable: false
    //             }

    //         }
    //     }
    // }

    // if ( this.state.firstName !== "" || this.state.lastName !== "" || this.state.gender !== "" || this.state.dateofbirth !== "" || this.state.userName !==  "" || this.state.mobilenumber !== "" || this.state.emailId !=="" || this.state.address !=="" || this.state.address2 !== "" || this.state.city !=="" || this.state.pincode !== "" || this.state.password !==  "" || this.state.confirmPassword !== "" ||  this.state.secretPassword !== "" || value === ""
    // ||  this.state.correctFirstname === true ||  this.state.correctPassword === true ||  this.state.correctLastname === true ||  this.state.correctUsername === true ||  this.state.correctAddress === true ||  this.state.correctAddress1 === true ||  this.state.correctAnswer === true ||  this.state.correctEmail === true ||  this.state.correctCity === true ||  this.state.correctState === true ||  this.state.correctPincode === true ||  this.state.correctPassword === true ||  this.state.correctConfirmPassword === true )  {
    //     // 


    // if (this.state.firstName !== "" && this.state.lastName !== "" && this.state.userName !== "" && this.state.mobileNumber !== "" && this.state.emailId !== "" && this.state.address !== "" && this.state.address2 !== "" && this.state.city !== "" && this.state.state !== "" && this.state.pincode !== "" && this.state.password !== "" && this.state.confirmPassword !== ""          ) {

    //     
    //     
    //     
    //     
    //     
    //     
    //     
    //     
    //     
    //     
    //     
    //     
    //     
    //     
    //     
    //     
    //     
    //     
    //     
    //     
    //     
    //     // 
    //     
    //     
    //     
    //     
    //     
    //     


    //     this.setState({
    //         correctPassword: this.state.password !== "" ,
    //         correctFirstname: this.state.firstName !== "",
    //         correctLastname: this.state.lastName !== "",
    //         correctUsername: this.state.userName !== "",
    //         correctAddress: this.state.address,
    //         correctAnswer: this.state.secretAnswer,
    //         correctEmail: this.state.emailId !== "",
    //         correctCity: this.state.city !== "",
    //         correctState: this.state.state !== "",
    //         correctMobileNumber: this.state.mobileNumber !== "",
    //         correctConfirmPassword: this.state.confirmPassword !== "",
    //         correctPincode: this.state.pincode !== "",

    //         stepIndex: 2,
    //         // submitBtndisabled: false,


    //     })
    //     


    // }
    // else if( ){
    //     
    //     
    //     
    //     
    //     
    //     
    //     
    //     
    //     
    //     
    //     
    //     
    //     
    //     
    //     
    //     this.setState({
    //         correctPassword: this.state.password !== "" ,
    //         correctFirstname: this.state.firstName !== "",
    //         correctLastname: this.state.lastName !== "",
    //         correctUsername: this.state.userName !== "",
    //         correctAddress: this.state.address,
    //         correctAnswer: this.state.secretAnswer,
    //         correctEmail: this.state.emailId !== "",
    //         correctCity: this.state.city !== "",
    //         correctState: this.state.state !== "",
    //         correctMobileNumber: this.state.mobileNumber !== "",
    //         correctConfirmPassword: this.state.confirmPassword !== "",
    //         correctPincode: this.state.pincode !== "",
    //         // disabled: true,
    //         stepIndex: 1,
    //     })
    //     // 
    //     
    //     
    //     
    //     
    //     
    //     
    //     
    //     
    //     
    //     
    //     
    // }






    handleVerifyFilled = () => {
        const { emailId, mobileNumber, userName, password, secretAnswer } = this.state
        if (emailId !== "" && mobileNumber !== "" && userName !== "" && password !== "" && secretAnswer !== "") {
            this.setState({
                disabledBtn: false
            })
        } else {
            this.setState({
                disabledBtn: true
            })
        }
        this.setState({
            loader: false
        })
    }

    handleActiveUser() {
        const { publicKey } = this.props
        const { expiry, pin, confirmPin } = this.state;

        // 
        let expiryDate = expiry.replace("/", "");
        if (expiry === "") {
            this.setState({
                // expiryError: true 
            })
        } else {
            this.setState({ expiryError: false })
        }
        if (pin === "") {
            // 
            this.setState({
                // pinError: true
            })
        } else {
            this.setState({ pinError: false })
        }
        if (confirmPin === "") {
            this.setState({ confirmPinError: true })
        } else {
            this.setState({ confirmPinError: false })
        }
        // this.setState({ stepIndex: 1 })
        let _this = this
        if (pin !== "" && confirmPin !== "" && expiry !== "") {
            if (pin === confirmPin) {
                if (publicKey.status === 200) {
                    const public_Key = publicKey.body.publickey;
                    let encrypt = new JSEncrypt();
                    encrypt.setPublicKey(public_Key);
                    const state = {
                        expDate: encrypt.encrypt(expiryDate),
                        cardNumber: localStorage.getItem("cardNumber"),
                        // cardNumber: this.props.cardNumber,
                        pin: encrypt.encrypt(this.state.pin),
                        applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',
                        updateSecurityInfo: "Y"
                    }
                    console.log("Sending data handleActivateUser", state)
                    this.setState({
                        loader: true
                    })

                    let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ
                    let traceId = getClientId();

                    fetch(plink + services.activate_card, {
                        method: 'POST',
                        headers: new Headers({
                            'Content-Type': 'application/json',
                            'X-Trace-Id': traceId,
                            'X-Client-APP': buildClientHeader(),
                        }),
                        body: JSON.stringify(state)
                    })
                        .then(response => {
                            if (response.status === 200 || response.status === 201) {
                                toast.success(response.headers.get('message'), {
                                    position: "top-right",
                                    draggablePercent: 60,
                                    autoClose: 3000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: false
                                }, 3000);
                                this.setState({
                                    loader: false
                                })

                                response.json().then(function (object) {
                                    _this.setState({
                                        activatedCardNumber: object.cardNumber,
                                        activatedExpDate: object.expDate,
                                        activatedFirstName: object.firstName,
                                        activatedLastName: object.lastName
                                    })

                                    localStorage.setItem("accountId", object.accountId)
                                })
                                // 
                            } else {
                                this.setState({
                                    loader: false
                                })
                                toast.error(response.headers.get('message'), {
                                    position: "top-right",
                                    autoClose: 5000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true
                                });
                            }
                        })
                }
            } else {
                this.setState({
                    loader: false
                })
                toast.error("PIN And Confirm PIN do not match !", {
                    position: "top-right",
                    autoClose: true,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true
                });
            }
        }

    }


    disableBtn = () => {

        var returnvalue = true
        if ((this.state.pinError === false) && (this.state.confirmPinError === false) && (this.state.PinMatchecdError === false)) {
            if (this.state.pin && this.state.confirmPin && this.state.expiryVerified === true) {

                returnvalue = false
            }
        }
        return returnvalue
    }
    getSteps = () => {
        if (this.state.stepIndex === 0) {
            return ['Create Your PIN']
        }
        else if ((this.state.existingUser === 'yes' || this.state.existingUser === 'true') && this.state.stepIndex === 0) {
            return ['Create Your PIN', 'Login']
        }
        else if ((this.state.existingUser === 'yes' || this.state.existingUser === 'true') && this.state.stepIndex === 1) {
            return ['Login']
        }
        else if ((this.state.existingUser === 'no' || this.state.existingUser === 'false') && this.state.stepIndex === 0) {
            return ['Create Your PIN', 'User Information', 'Verify & Register'];
        }
        else if ((this.state.existingUser === 'no' || this.state.existingUser === 'false') && this.state.stepIndex === 1) {
            return ['User Information', 'Verify & Register'];
        }

    }
    handleContactPage = () => {
        this.props.history.push("/contact-us")
    }
    handleCheckbox = () => {
        this.setState({
            KycConsent: !this.state.KycConsent
        }, () => {

            console.log(this.state.KycConsent)
            if (this.state.firstName !== "" && this.state.countryName1 !== "" && this.state.countryName !== "" && this.state.firstName !== null && this.state.validUserName === true && this.state.lastName !== "" && this.state.lastName !== null && this.state.userName !== "" && this.state.userName !== null && this.state.mobileNumber !== "" && this.state.mobileNumber !== null && this.state.address !== "" && this.state.address !== null && this.state.city !== "" && this.state.city !== null && this.state.state !== "" && this.state.state !== null && this.state.pincode !== "" && this.state.pincode !== null && this.state.password !== "" && this.state.password !== null && this.state.confirmPassword !== "" && this.state.confirmPassword !== null && this.state.emailId !== null && this.state.secretAnswer !== ""
                && this.state.streetNumber !== "" && this.state.state1 !== "" && this.state.idNumber !== "" && this.state.dateofbirth !== "" && this.state.correctFirstname === true && this.state.correctLastname === true && this.state.correctUsername === true && this.state.correctMobileNumber === true && this.state.correctPassword === true && this.state.correctAddress === true && this.state.correctAnswer === true && this.state.correctEmail === true && this.state.correctCity === true && this.state.correctState === true && this.state.correctPincode === true && this.state.correctPassword === true && this.state.correctConfirmPassword === true && this.state.correctEmail === true && this.state.KycConsent === true) {



                this.setState({
                    // stepIndex: 2,
                    submitBtndisabled: false
                })

            }
            else {


                this.setState({
                    submitBtndisabled: true
                })
            }

        })
    }





    render() {

        // const cardtype = localStorage.getItem('cardTypes')
        // const baseCardType = cardtype && cardtype.replace(/D$/, '');
        // const { stepIndex, parsedErrors } = this.state;


        const cardtype = localStorage.getItem('cardTypes') || localStorage.getItem('cardType')
        const baseCardType = cardtype && cardtype.replace(/D$/, '');
        const { stepIndex, parsedErrors } = this.state;

        const height = $(window).height();

        return (

            <div style={{ minHeight: height }}>

                {this.state.openModal && <UserModal
                    open={this.state.openModal}
                    onClose={this.closeUserModal}
                    handleOld={this.handleOldUser}
                    handleNew={this.handleNewUser}
                />}

                {this.state.activationfailed && <ActivationFailed
                    open={this.state.activationfailed}
                    onClose={this.closefailedModal}
                    handleContactUs={this.handleContactPage}
                    message={this.state.message}
                    attempts={this.state.attempts}

                />}


                {this.state.activationsuccess && <ActivationSuccess
                    open={this.state.activationsuccess}
                    message={this.state.message}
                    onClose={this.closeSuccessModal}

                />}

                {this.getStepContent(stepIndex)}



                <div style={{ marginBottom: 12, }}>

                    {baseCardType === "G" || baseCardType === "R" || baseCardType === "A" ?
                        <div className="col-sm-12 nopadding" style={{ position: "absolute !important" }}>
                            {(stepIndex === 1 && ((this.state.existingUser === "no" || this.state.existingUser === "false") || localStorage.getItem('existingUser') === "false")) &&
                                <div className="row">
                                    <div className="col-md-12" style={{ textAlign: "center", marginTop: "0px" }}>
                                        <RaisedButton
                                            disabled={this.state.disabledBtn}
                                            label={'Submit'}
                                            onClick={stepIndex === 1 ? this.handleUserInfo : null}
                                            style={styles.button}
                                            className="btn-std"
                                            backgroundColor="#FFCE39"
                                            labelColor="#115876"
                                            marginTop="10px"
                                        />
                                    </div>
                                </div>
                            }

                            {(this.state.existingUser === "no" || this.state.existingUser === "false") ?
                                <div className="col-md-12 " style={{ textAlign: "center" }}>
                                </div>
                                :
                                <div></div>
                            }
                        </div>

                        :

                        <div></div>
                    }
                    {this.state.stepIndex === 0 &&
                        <div className="col-md-12 mt-3 " style={{ textAlign: "center", }}>
                            <RaisedButton
                                disabled={this.disableBtn()}
                                label={'Next'}
                                onClick={this.handleActivate}
                                style={styles.button}
                                className="btn-std"
                                backgroundColor="#FFCE39"
                                labelColor="#115876"
                            />
                        </div>
                    }

                </div>

                {this.state.loader === true &&
                    <div className="col-sm-1" style={{ marginTop: "-61px", marginLeft: "90px", width: "30% !mportant" }} >
                        <LoaderSmall />
                    </div>}
                {stepIndex === 2 &&
                    <div style={{ marginTop: "0px", display: "flex" }}>
                        <RaisedButton
                            label="back"
                            onClick={this.handleback}
                            style={styles.button}
                            className="btn-std ml-2"
                            backgroundColor="#FFCE39"
                            labelColor="#115876"
                        />

                        <RaisedButton
                            disabled={this.state.verifyBtndisabled}
                            label="Submit"
                            onClick={this.handleVerify}
                            // onClick={this.handleVerifyCallback}
                            style={styles.button}
                            className="btn-std ml-2"
                            backgroundColor="#FFCE39"
                            labelColor="#115876"
                        />
                    </div>
                }
                {stepIndex === 3 &&
                    <div style={{ marginTop: "0px", display: "flex" }}>


                        <RaisedButton

                            label="Submit"
                            onClick={this.completeRegistrationWithPin}
                            // onClick={this.handleVerifyCallback}
                            style={styles.button}
                            className="btn-std ml-2"
                            backgroundColor="#FFCE39"
                            labelColor="#115876"
                        />
                    </div>
                }

                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop
                    closeOnClick
                    rtl={false}
                    pauseOnVisibilityChange
                    draggable
                    pauseOnHover
                />
            </div>
        );
    }
}


Activate.propTypes = {
    keyRecieved: PropTypes.bool
};
Activate.defaultProps = {
    keyRecieved: false
};


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Activate));


// WEBPACK FOOTER //
// ./src/components/register/activate.jsx